(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb33b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb33b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5NIBB", function(module, exports) {
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.8'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(const key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        // use dummy base URL to allow normalize on path only
        const url = new URL(path, 'http://x');
        if (url) path = url.pathname + url.search;
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const normalizedId = id.replace("'", "\\'");
                const normalizedTag = newNode.tagName.replace(':', '\\:');
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(normalizedTag + "[id='" + normalizedId + "']");
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            const rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            target.classList.remove(htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) elt.classList.add(htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) elt.classList.remove(htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody);
            for(const eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            const btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            const link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            const samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for(const e in extensions){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error);
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            ic.classList.add.call(ic.classList, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            disabledElement.setAttribute('disabled', '');
            disabledElement.setAttribute('data-disabled-by-htmx', '');
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) ic.classList.remove.call(ic.classList, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(const key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for(const key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(const header in headers)if (headers.hasOwnProperty(header)) {
                const headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        const pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        const replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // false indicates no push, return empty object
            if (path === 'false') return {};
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push || 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        const shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            target.classList.add(htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            const indicator = htmx.config.indicatorClass;
            const request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', `<style${nonceAttribute}>` + `.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}` + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $439421104d3ae135$export$2e2bcd8739ae039 = htmx;

});

parcelRequire("5NIBB");
var $10c52594aaf0c6b9$exports = {};
(function(e, t) {
    const r = t(e);
    if (typeof $10c52594aaf0c6b9$exports["nodeName"] !== "string") $10c52594aaf0c6b9$exports = r;
    else {
        e["_hyperscript"] = r;
        if ("document" in e) e["_hyperscript"].browserInit();
    }
})(typeof self !== "undefined" ? self : $10c52594aaf0c6b9$exports, (e)=>{
    "use strict";
    const t = {
        dynamicResolvers: [
            function(e, t) {
                if (e === "Fixed") return Number(t).toFixed();
                else if (e.indexOf("Fixed:") === 0) {
                    let r = e.split(":")[1];
                    return Number(t).toFixed(parseInt(r));
                }
            }
        ],
        String: function(e) {
            if (e.toString) return e.toString();
            else return "" + e;
        },
        Int: function(e) {
            return parseInt(e);
        },
        Float: function(e) {
            return parseFloat(e);
        },
        Number: function(e) {
            return Number(e);
        },
        Date: function(e) {
            return new Date(e);
        },
        Array: function(e) {
            return Array.from(e);
        },
        JSON: function(e) {
            return JSON.stringify(e);
        },
        Object: function(e) {
            if (e instanceof String) e = e.toString();
            if (typeof e === "string") return JSON.parse(e);
            else return Object.assign({}, e);
        }
    };
    const r = {
        attributes: "_, script, data-script",
        defaultTransition: "all 500ms ease-in",
        disableSelector: "[disable-scripting], [data-disable-scripting]",
        hideShowStrategies: {},
        conversions: t
    };
    class n {
        static OP_TABLE = {
            "+": "PLUS",
            "-": "MINUS",
            "*": "MULTIPLY",
            "/": "DIVIDE",
            ".": "PERIOD",
            "..": "ELLIPSIS",
            "\\": "BACKSLASH",
            ":": "COLON",
            "%": "PERCENT",
            "|": "PIPE",
            "!": "EXCLAMATION",
            "?": "QUESTION",
            "#": "POUND",
            "&": "AMPERSAND",
            $: "DOLLAR",
            ";": "SEMI",
            ",": "COMMA",
            "(": "L_PAREN",
            ")": "R_PAREN",
            "<": "L_ANG",
            ">": "R_ANG",
            "<=": "LTE_ANG",
            ">=": "GTE_ANG",
            "==": "EQ",
            "===": "EQQ",
            "!=": "NEQ",
            "!==": "NEQQ",
            "{": "L_BRACE",
            "}": "R_BRACE",
            "[": "L_BRACKET",
            "]": "R_BRACKET",
            "=": "EQUALS",
            "~": "TILDE"
        };
        static isValidCSSClassChar(e) {
            return n.isAlpha(e) || n.isNumeric(e) || e === "-" || e === "_" || e === ":";
        }
        static isValidCSSIDChar(e) {
            return n.isAlpha(e) || n.isNumeric(e) || e === "-" || e === "_" || e === ":";
        }
        static isWhitespace(e) {
            return e === " " || e === "\t" || n.isNewline(e);
        }
        static positionString(e) {
            return "[Line: " + e.line + ", Column: " + e.column + "]";
        }
        static isNewline(e) {
            return e === "\r" || e === "\n";
        }
        static isNumeric(e) {
            return e >= "0" && e <= "9";
        }
        static isAlpha(e) {
            return e >= "a" && e <= "z" || e >= "A" && e <= "Z";
        }
        static isIdentifierChar(e, t) {
            return e === "_" || e === "$";
        }
        static isReservedChar(e) {
            return e === "`" || e === "^";
        }
        static isValidSingleQuoteStringStart(e) {
            if (e.length > 0) {
                var t = e[e.length - 1];
                if (t.type === "IDENTIFIER" || t.type === "CLASS_REF" || t.type === "ID_REF") return false;
                if (t.op && (t.value === ">" || t.value === ")")) return false;
            }
            return true;
        }
        static tokenize(e, t) {
            var r = [];
            var a = e;
            var o = 0;
            var s = 0;
            var u = 1;
            var l = "<START>";
            var c = 0;
            function f() {
                return t && c === 0;
            }
            while(o < a.length){
                if (q() === "-" && I() === "-" && (n.isWhitespace(C(2)) || C(2) === "" || C(2) === "-") || q() === "/" && I() === "/" && (n.isWhitespace(C(2)) || C(2) === "" || C(2) === "/")) h();
                else if (q() === "/" && I() === "*" && (n.isWhitespace(C(2)) || C(2) === "" || C(2) === "*")) v();
                else {
                    if (n.isWhitespace(q())) r.push(L());
                    else if (!A() && q() === "." && (n.isAlpha(I()) || I() === "{" || I() === "-")) r.push(d());
                    else if (!A() && q() === "#" && (n.isAlpha(I()) || I() === "{")) r.push(k());
                    else if (q() === "[" && I() === "@") r.push(E());
                    else if (q() === "@") r.push(T());
                    else if (q() === "*" && n.isAlpha(I())) r.push(y());
                    else if (f() && (n.isAlpha(q()) || q() === "\\")) r.push(x());
                    else if (!f() && (n.isAlpha(q()) || n.isIdentifierChar(q()))) r.push(g());
                    else if (n.isNumeric(q())) r.push(b());
                    else if (!f() && (q() === '"' || q() === "`")) r.push(S());
                    else if (!f() && q() === "'") {
                        if (n.isValidSingleQuoteStringStart(r)) r.push(S());
                        else r.push(w());
                    } else if (n.OP_TABLE[q()]) {
                        if (l === "$" && q() === "{") c++;
                        if (q() === "}") c--;
                        r.push(w());
                    } else if (f() || n.isReservedChar(q())) r.push(p("RESERVED", R()));
                    else {
                        if (o < a.length) throw Error("Unknown token: " + q() + " ");
                    }
                }
            }
            return new i(r, [], a);
            function m(e, t) {
                var r = p(e, t);
                r.op = true;
                return r;
            }
            function p(e, t) {
                return {
                    type: e,
                    value: t || "",
                    start: o,
                    end: o + 1,
                    column: s,
                    line: u
                };
            }
            function h() {
                while(q() && !n.isNewline(q()))R();
                R();
            }
            function v() {
                while(q() && !(q() === "*" && I() === "/"))R();
                R();
                R();
            }
            function d() {
                var e = p("CLASS_REF");
                var t = R();
                if (q() === "{") {
                    e.template = true;
                    t += R();
                    while(q() && q() !== "}")t += R();
                    if (q() !== "}") throw Error("Unterminated class reference");
                    else t += R();
                } else while(n.isValidCSSClassChar(q()) || q() === "\\"){
                    if (q() === "\\") R();
                    t += R();
                }
                e.value = t;
                e.end = o;
                return e;
            }
            function E() {
                var e = p("ATTRIBUTE_REF");
                var t = R();
                while(o < a.length && q() !== "]")t += R();
                if (q() === "]") t += R();
                e.value = t;
                e.end = o;
                return e;
            }
            function T() {
                var e = p("ATTRIBUTE_REF");
                var t = R();
                while(n.isValidCSSIDChar(q()))t += R();
                if (q() === "=") {
                    t += R();
                    if (q() === '"' || q() === "'") {
                        let e = S();
                        t += e.value;
                    } else if (n.isAlpha(q()) || n.isNumeric(q()) || n.isIdentifierChar(q())) {
                        let e = g();
                        t += e.value;
                    }
                }
                e.value = t;
                e.end = o;
                return e;
            }
            function y() {
                var e = p("STYLE_REF");
                var t = R();
                while(n.isAlpha(q()) || q() === "-")t += R();
                e.value = t;
                e.end = o;
                return e;
            }
            function k() {
                var e = p("ID_REF");
                var t = R();
                if (q() === "{") {
                    e.template = true;
                    t += R();
                    while(q() && q() !== "}")t += R();
                    if (q() !== "}") throw Error("Unterminated id reference");
                    else R();
                } else while(n.isValidCSSIDChar(q()))t += R();
                e.value = t;
                e.end = o;
                return e;
            }
            function x() {
                var e = p("IDENTIFIER");
                var t = R();
                var r = t === "\\";
                if (r) t = "";
                while(n.isAlpha(q()) || n.isNumeric(q()) || n.isIdentifierChar(q()) || q() === "\\" || q() === "{" || q() === "}"){
                    if (q() === "$" && r === false) break;
                    else if (q() === "\\") {
                        r = true;
                        R();
                    } else {
                        r = false;
                        t += R();
                    }
                }
                if (q() === "!" && t === "beep") t += R();
                e.value = t;
                e.end = o;
                return e;
            }
            function g() {
                var e = p("IDENTIFIER");
                var t = R();
                while(n.isAlpha(q()) || n.isNumeric(q()) || n.isIdentifierChar(q()))t += R();
                if (q() === "!" && t === "beep") t += R();
                e.value = t;
                e.end = o;
                return e;
            }
            function b() {
                var e = p("NUMBER");
                var t = R();
                while(n.isNumeric(q()))t += R();
                if (q() === "." && n.isNumeric(I())) t += R();
                while(n.isNumeric(q()))t += R();
                if (q() === "e" || q() === "E") {
                    if (n.isNumeric(I())) t += R();
                    else if (I() === "-") {
                        t += R();
                        t += R();
                    }
                }
                while(n.isNumeric(q()))t += R();
                e.value = t;
                e.end = o;
                return e;
            }
            function w() {
                var e = m();
                var t = R();
                while(q() && n.OP_TABLE[t + q()])t += R();
                e.type = n.OP_TABLE[t];
                e.value = t;
                e.end = o;
                return e;
            }
            function S() {
                var e = p("STRING");
                var t = R();
                e.template = t === "`";
                var r = "";
                while(q() && q() !== t)if (q() === "\\") {
                    R();
                    let t = R();
                    if (t === "b") r += "\b";
                    else if (t === "f") r += "\f";
                    else if (t === "n") r += "\n";
                    else if (t === "r") r += "\r";
                    else if (t === "t") r += "\t";
                    else if (t === "v") r += "\v";
                    else if (e.template && t === "$") r += "\\$";
                    else if (t === "x") {
                        const t = N();
                        if (Number.isNaN(t)) throw Error("Invalid hexadecimal escape at " + n.positionString(e));
                        r += String.fromCharCode(t);
                    } else r += t;
                } else r += R();
                if (q() !== t) throw Error("Unterminated string at " + n.positionString(e));
                else R();
                e.value = r;
                e.end = o;
                return e;
            }
            function N() {
                const e = 16;
                if (!q()) return NaN;
                let t = e * Number.parseInt(R(), e);
                if (!q()) return NaN;
                t += Number.parseInt(R(), e);
                return t;
            }
            function q() {
                return a.charAt(o);
            }
            function I() {
                return a.charAt(o + 1);
            }
            function C(e = 1) {
                return a.charAt(o + e);
            }
            function R() {
                l = q();
                o++;
                s++;
                return l;
            }
            function A() {
                return n.isAlpha(l) || n.isNumeric(l) || l === ")" || l === '"' || l === "'" || l === "`" || l === "}" || l === "]";
            }
            function L() {
                var e = p("WHITESPACE");
                var t = "";
                while(q() && n.isWhitespace(q())){
                    if (n.isNewline(q())) {
                        s = 0;
                        u++;
                    }
                    t += R();
                }
                e.value = t;
                e.end = o;
                return e;
            }
        }
        tokenize(e, t) {
            return n.tokenize(e, t);
        }
    }
    class i {
        constructor(e, t, r){
            this.tokens = e;
            this.consumed = t;
            this.source = r;
            this.consumeWhitespace();
        }
        get list() {
            return this.tokens;
        }
        _lastConsumed = null;
        consumeWhitespace() {
            while(this.token(0, true).type === "WHITESPACE")this.consumed.push(this.tokens.shift());
        }
        raiseError(e, t) {
            a.raiseParseError(e, t);
        }
        requireOpToken(e) {
            var t = this.matchOpToken(e);
            if (t) return t;
            else this.raiseError(this, "Expected '" + e + "' but found '" + this.currentToken().value + "'");
        }
        matchAnyOpToken(e, t, r) {
            for(var n = 0; n < arguments.length; n++){
                var i = arguments[n];
                var a = this.matchOpToken(i);
                if (a) return a;
            }
        }
        matchAnyToken(e, t, r) {
            for(var n = 0; n < arguments.length; n++){
                var i = arguments[n];
                var a = this.matchToken(i);
                if (a) return a;
            }
        }
        matchOpToken(e) {
            if (this.currentToken() && this.currentToken().op && this.currentToken().value === e) return this.consumeToken();
        }
        requireTokenType(e, t, r, n) {
            var i = this.matchTokenType(e, t, r, n);
            if (i) return i;
            else this.raiseError(this, "Expected one of " + JSON.stringify([
                e,
                t,
                r
            ]));
        }
        matchTokenType(e, t, r, n) {
            if (this.currentToken() && this.currentToken().type && [
                e,
                t,
                r,
                n
            ].indexOf(this.currentToken().type) >= 0) return this.consumeToken();
        }
        requireToken(e, t) {
            var r = this.matchToken(e, t);
            if (r) return r;
            else this.raiseError(this, "Expected '" + e + "' but found '" + this.currentToken().value + "'");
        }
        peekToken(e, t, r) {
            t = t || 0;
            r = r || "IDENTIFIER";
            if (this.tokens[t] && this.tokens[t].value === e && this.tokens[t].type === r) return this.tokens[t];
        }
        matchToken(e, t) {
            if (this.follows.indexOf(e) !== -1) return;
            t = t || "IDENTIFIER";
            if (this.currentToken() && this.currentToken().value === e && this.currentToken().type === t) return this.consumeToken();
        }
        consumeToken() {
            var e = this.tokens.shift();
            this.consumed.push(e);
            this._lastConsumed = e;
            this.consumeWhitespace();
            return e;
        }
        consumeUntil(e, t) {
            var r = [];
            var n = this.token(0, true);
            while((t == null || n.type !== t) && (e == null || n.value !== e) && n.type !== "EOF"){
                var i = this.tokens.shift();
                this.consumed.push(i);
                r.push(n);
                n = this.token(0, true);
            }
            this.consumeWhitespace();
            return r;
        }
        lastWhitespace() {
            if (this.consumed[this.consumed.length - 1] && this.consumed[this.consumed.length - 1].type === "WHITESPACE") return this.consumed[this.consumed.length - 1].value;
            else return "";
        }
        consumeUntilWhitespace() {
            return this.consumeUntil(null, "WHITESPACE");
        }
        hasMore() {
            return this.tokens.length > 0;
        }
        token(e, t) {
            var r;
            var n = 0;
            do {
                if (!t) while(this.tokens[n] && this.tokens[n].type === "WHITESPACE")n++;
                r = this.tokens[n];
                e--;
                n++;
            }while (e > -1);
            if (r) return r;
            else return {
                type: "EOF",
                value: "<<<EOF>>>"
            };
        }
        currentToken() {
            return this.token(0);
        }
        lastMatch() {
            return this._lastConsumed;
        }
        static sourceFor = function() {
            return this.programSource.substring(this.startToken.start, this.endToken.end);
        };
        static lineFor = function() {
            return this.programSource.split("\n")[this.startToken.line - 1];
        };
        follows = [];
        pushFollow(e) {
            this.follows.push(e);
        }
        popFollow() {
            this.follows.pop();
        }
        clearFollows() {
            var e = this.follows;
            this.follows = [];
            return e;
        }
        restoreFollows(e) {
            this.follows = e;
        }
    }
    class a {
        constructor(e){
            this.runtime = e;
            this.possessivesDisabled = false;
            this.addGrammarElement("feature", function(e, t, r) {
                if (r.matchOpToken("(")) {
                    var n = e.requireElement("feature", r);
                    r.requireOpToken(")");
                    return n;
                }
                var i = e.FEATURES[r.currentToken().value || ""];
                if (i) return i(e, t, r);
            });
            this.addGrammarElement("command", function(e, t, r) {
                if (r.matchOpToken("(")) {
                    const t = e.requireElement("command", r);
                    r.requireOpToken(")");
                    return t;
                }
                var n = e.COMMANDS[r.currentToken().value || ""];
                let i;
                if (n) i = n(e, t, r);
                else if (r.currentToken().type === "IDENTIFIER") i = e.parseElement("pseudoCommand", r);
                if (i) return e.parseElement("indirectStatement", r, i);
                return i;
            });
            this.addGrammarElement("commandList", function(e, t, r) {
                if (r.hasMore()) {
                    var n = e.parseElement("command", r);
                    if (n) {
                        r.matchToken("then");
                        const t = e.parseElement("commandList", r);
                        if (t) n.next = t;
                        return n;
                    }
                }
                return {
                    type: "emptyCommandListCommand",
                    op: function(e) {
                        return t.findNext(this, e);
                    },
                    execute: function(e) {
                        return t.unifiedExec(this, e);
                    }
                };
            });
            this.addGrammarElement("leaf", function(e, t, r) {
                var n = e.parseAnyOf(e.LEAF_EXPRESSIONS, r);
                if (n == null) return e.parseElement("symbol", r);
                return n;
            });
            this.addGrammarElement("indirectExpression", function(e, t, r, n) {
                for(var i = 0; i < e.INDIRECT_EXPRESSIONS.length; i++){
                    var a = e.INDIRECT_EXPRESSIONS[i];
                    n.endToken = r.lastMatch();
                    var o = e.parseElement(a, r, n);
                    if (o) return o;
                }
                return n;
            });
            this.addGrammarElement("indirectStatement", function(e, t, r, n) {
                if (r.matchToken("unless")) {
                    n.endToken = r.lastMatch();
                    var i = e.requireElement("expression", r);
                    var a = {
                        type: "unlessStatementModifier",
                        args: [
                            i
                        ],
                        op: function(e, t) {
                            if (t) return this.next;
                            else return n;
                        },
                        execute: function(e) {
                            return t.unifiedExec(this, e);
                        }
                    };
                    n.parent = a;
                    return a;
                }
                return n;
            });
            this.addGrammarElement("primaryExpression", function(e, t, r) {
                var n = e.parseElement("leaf", r);
                if (n) return e.parseElement("indirectExpression", r, n);
                e.raiseParseError(r, "Unexpected value: " + r.currentToken().value);
            });
        }
        use(e) {
            e(this);
            return this;
        }
        GRAMMAR = {};
        COMMANDS = {};
        FEATURES = {};
        LEAF_EXPRESSIONS = [];
        INDIRECT_EXPRESSIONS = [];
        initElt(e, t, r) {
            e.startToken = t;
            e.sourceFor = i.sourceFor;
            e.lineFor = i.lineFor;
            e.programSource = r.source;
        }
        parseElement(e, t, r) {
            var n = this.GRAMMAR[e];
            if (n) {
                var i = t.currentToken();
                var a = n(this, this.runtime, t, r);
                if (a) {
                    this.initElt(a, i, t);
                    a.endToken = a.endToken || t.lastMatch();
                    var r = a.root;
                    while(r != null){
                        this.initElt(r, i, t);
                        r = r.root;
                    }
                }
                return a;
            }
        }
        requireElement(e, t, r, n) {
            var i = this.parseElement(e, t, n);
            if (!i) a.raiseParseError(t, r || "Expected " + e);
            return i;
        }
        parseAnyOf(e, t) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                var i = this.parseElement(n, t);
                if (i) return i;
            }
        }
        addGrammarElement(e, t) {
            this.GRAMMAR[e] = t;
        }
        addCommand(e, t) {
            var r = e + "Command";
            var n = function(e, n, i) {
                const a = t(e, n, i);
                if (a) {
                    a.type = r;
                    a.execute = function(e) {
                        e.meta.command = a;
                        return n.unifiedExec(this, e);
                    };
                    return a;
                }
            };
            this.GRAMMAR[r] = n;
            this.COMMANDS[e] = n;
        }
        addFeature(e, t) {
            var r = e + "Feature";
            var n = function(n, i, a) {
                var o = t(n, i, a);
                if (o) {
                    o.isFeature = true;
                    o.keyword = e;
                    o.type = r;
                    return o;
                }
            };
            this.GRAMMAR[r] = n;
            this.FEATURES[e] = n;
        }
        addLeafExpression(e, t) {
            this.LEAF_EXPRESSIONS.push(e);
            this.addGrammarElement(e, t);
        }
        addIndirectExpression(e, t) {
            this.INDIRECT_EXPRESSIONS.push(e);
            this.addGrammarElement(e, t);
        }
        static createParserContext(e) {
            var t = e.currentToken();
            var r = e.source;
            var n = r.split("\n");
            var i = t && t.line ? t.line - 1 : n.length - 1;
            var a = n[i];
            var o = t && t.line ? t.column : a.length - 1;
            return a + "\n" + " ".repeat(o) + "^^\n\n";
        }
        static raiseParseError(e, t) {
            t = (t || "Unexpected Token : " + e.currentToken().value) + "\n\n" + a.createParserContext(e);
            var r = new Error(t);
            r["tokens"] = e;
            throw r;
        }
        raiseParseError(e, t) {
            a.raiseParseError(e, t);
        }
        parseHyperScript(e) {
            var t = this.parseElement("hyperscript", e);
            if (e.hasMore()) this.raiseParseError(e);
            if (t) return t;
        }
        setParent(e, t) {
            if (typeof e === "object") {
                e.parent = t;
                if (typeof t === "object") {
                    t.children = t.children || new Set;
                    t.children.add(e);
                }
                this.setParent(e.next, t);
            }
        }
        commandStart(e) {
            return this.COMMANDS[e.value || ""];
        }
        featureStart(e) {
            return this.FEATURES[e.value || ""];
        }
        commandBoundary(e) {
            if (e.value == "end" || e.value == "then" || e.value == "else" || e.value == "otherwise" || e.value == ")" || this.commandStart(e) || this.featureStart(e) || e.type == "EOF") return true;
            return false;
        }
        parseStringTemplate(e) {
            var t = [
                ""
            ];
            do {
                t.push(e.lastWhitespace());
                if (e.currentToken().value === "$") {
                    e.consumeToken();
                    var r = e.matchOpToken("{");
                    t.push(this.requireElement("expression", e));
                    if (r) e.requireOpToken("}");
                    t.push("");
                } else if (e.currentToken().value === "\\") {
                    e.consumeToken();
                    e.consumeToken();
                } else {
                    var n = e.consumeToken();
                    t[t.length - 1] += n ? n.value : "";
                }
            }while (e.hasMore());
            t.push(e.lastWhitespace());
            return t;
        }
        ensureTerminated(e) {
            const t = this.runtime;
            var r = {
                type: "implicitReturn",
                op: function(e) {
                    e.meta.returned = true;
                    if (e.meta.resolve) e.meta.resolve();
                    return t.HALT;
                },
                execute: function(e) {}
            };
            var n = e;
            while(n.next)n = n.next;
            n.next = r;
        }
    }
    class o {
        constructor(e, t){
            this.lexer = e ?? new n;
            this.parser = t ?? new a(this).use(T).use(y);
            this.parser.runtime = this;
        }
        matchesSelector(e, t) {
            var r = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector;
            return r && r.call(e, t);
        }
        makeEvent(t, r) {
            var n;
            if (e.Event && typeof e.Event === "function") {
                n = new Event(t, {
                    bubbles: true,
                    cancelable: true,
                    composed: true
                });
                n["detail"] = r;
            } else {
                n = document.createEvent("CustomEvent");
                n.initCustomEvent(t, true, true, r);
            }
            return n;
        }
        triggerEvent(e, t, r, n) {
            r = r || {};
            r["sender"] = n;
            var i = this.makeEvent(t, r);
            var a = e.dispatchEvent(i);
            return a;
        }
        isArrayLike(e) {
            return Array.isArray(e) || typeof NodeList !== "undefined" && (e instanceof NodeList || e instanceof HTMLCollection || e instanceof FileList);
        }
        isIterable(e) {
            return typeof e === "object" && Symbol.iterator in e && typeof e[Symbol.iterator] === "function";
        }
        shouldAutoIterate(e) {
            return e != null && e[p] || this.isArrayLike(e);
        }
        forEach(e, t) {
            if (e == null) ;
            else if (this.isIterable(e)) for (const r of e)t(r);
            else if (this.isArrayLike(e)) for(var r = 0; r < e.length; r++)t(e[r]);
            else t(e);
        }
        implicitLoop(e, t) {
            if (this.shouldAutoIterate(e)) for (const r of e)t(r);
            else t(e);
        }
        wrapArrays(e) {
            var t = [];
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                if (Array.isArray(n)) t.push(Promise.all(n));
                else t.push(n);
            }
            return t;
        }
        unwrapAsyncs(e) {
            for(var t = 0; t < e.length; t++){
                var r = e[t];
                if (r.asyncWrapper) e[t] = r.value;
                if (Array.isArray(r)) for(var n = 0; n < r.length; n++){
                    var i = r[n];
                    if (i.asyncWrapper) r[n] = i.value;
                }
            }
        }
        static HALT = {};
        HALT = o.HALT;
        unifiedExec(e, t) {
            while(true){
                try {
                    var r = this.unifiedEval(e, t);
                } catch (n) {
                    if (t.meta.handlingFinally) {
                        console.error(" Exception in finally block: ", n);
                        r = o.HALT;
                    } else {
                        this.registerHyperTrace(t, n);
                        if (t.meta.errorHandler && !t.meta.handlingError) {
                            t.meta.handlingError = true;
                            t.locals[t.meta.errorSymbol] = n;
                            e = t.meta.errorHandler;
                            continue;
                        } else {
                            t.meta.currentException = n;
                            r = o.HALT;
                        }
                    }
                }
                if (r == null) {
                    console.error(e, " did not return a next element to execute! context: ", t);
                    return;
                } else if (r.then) {
                    r.then((e)=>{
                        this.unifiedExec(e, t);
                    }).catch((e)=>{
                        this.unifiedExec({
                            op: function() {
                                throw e;
                            }
                        }, t);
                    });
                    return;
                } else if (r === o.HALT) {
                    if (t.meta.finallyHandler && !t.meta.handlingFinally) {
                        t.meta.handlingFinally = true;
                        e = t.meta.finallyHandler;
                    } else {
                        if (t.meta.onHalt) t.meta.onHalt();
                        if (t.meta.currentException) {
                            if (t.meta.reject) {
                                t.meta.reject(t.meta.currentException);
                                return;
                            } else throw t.meta.currentException;
                        } else return;
                    }
                } else e = r;
            }
        }
        unifiedEval(e, t, r) {
            var n = [
                t
            ];
            var i = false;
            var a = false;
            if (e.args) for(var o = 0; o < e.args.length; o++){
                var s = e.args[o];
                if (s == null) n.push(null);
                else if (Array.isArray(s)) {
                    var u = [];
                    for(var l = 0; l < s.length; l++){
                        var c = s[l];
                        var f = c ? c.evaluate(t) : null;
                        if (f) {
                            if (f.then) i = true;
                            else if (f.asyncWrapper) a = true;
                        }
                        u.push(f);
                    }
                    n.push(u);
                } else if (s.evaluate) {
                    var f = s.evaluate(t);
                    if (f) {
                        if (f.then) i = true;
                        else if (f.asyncWrapper) a = true;
                    }
                    n.push(f);
                    if (f) {
                        if (r === true) break;
                    } else {
                        if (r === false) break;
                    }
                } else n.push(s);
            }
            if (i) return new Promise((t, r)=>{
                n = this.wrapArrays(n);
                Promise.all(n).then(function(n) {
                    if (a) this.unwrapAsyncs(n);
                    try {
                        var i = e.op.apply(e, n);
                        t(i);
                    } catch (e) {
                        r(e);
                    }
                }).catch(function(e) {
                    r(e);
                });
            });
            else {
                if (a) this.unwrapAsyncs(n);
                return e.op.apply(e, n);
            }
        }
        _scriptAttrs = null;
        getScriptAttributes() {
            if (this._scriptAttrs == null) this._scriptAttrs = r.attributes.replace(/ /g, "").split(",");
            return this._scriptAttrs;
        }
        getScript(e) {
            for(var t = 0; t < this.getScriptAttributes().length; t++){
                var r = this.getScriptAttributes()[t];
                if (e.hasAttribute && e.hasAttribute(r)) return e.getAttribute(r);
            }
            if (e instanceof HTMLScriptElement && e.type === "text/hyperscript") return e.innerText;
            return null;
        }
        hyperscriptFeaturesMap = new WeakMap;
        getHyperscriptFeatures(e) {
            var t = this.hyperscriptFeaturesMap.get(e);
            if (typeof t === "undefined") {
                if (e) this.hyperscriptFeaturesMap.set(e, t = {});
            }
            return t;
        }
        addFeatures(e, t) {
            if (e) {
                Object.assign(t.locals, this.getHyperscriptFeatures(e));
                this.addFeatures(e.parentElement, t);
            }
        }
        makeContext(e, t, r, n) {
            return new f(e, t, r, n, this);
        }
        getScriptSelector() {
            return this.getScriptAttributes().map(function(e) {
                return "[" + e + "]";
            }).join(", ");
        }
        convertValue(e, r) {
            var n = t.dynamicResolvers;
            for(var i = 0; i < n.length; i++){
                var a = n[i];
                var o = a(r, e);
                if (o !== undefined) return o;
            }
            if (e == null) return null;
            var s = t[r];
            if (s) return s(e);
            throw "Unknown conversion : " + r;
        }
        parse(e) {
            const t = this.lexer, r = this.parser;
            var n = t.tokenize(e);
            if (this.parser.commandStart(n.currentToken())) {
                var i = r.requireElement("commandList", n);
                if (n.hasMore()) r.raiseParseError(n);
                r.ensureTerminated(i);
                return i;
            } else if (r.featureStart(n.currentToken())) {
                var a = r.requireElement("hyperscript", n);
                if (n.hasMore()) r.raiseParseError(n);
                return a;
            } else {
                var o = r.requireElement("expression", n);
                if (n.hasMore()) r.raiseParseError(n);
                return o;
            }
        }
        evaluateNoPromise(e, t) {
            let r = e.evaluate(t);
            if (r.next) throw new Error(i.sourceFor.call(e) + " returned a Promise in a context that they are not allowed.");
            return r;
        }
        evaluate(t, r, n) {
            class i extends EventTarget {
                constructor(e){
                    super();
                    this.module = e;
                }
                toString() {
                    return this.module.id;
                }
            }
            var a = "document" in e ? e.document.body : new i(n && n.module);
            r = Object.assign(this.makeContext(a, null, a, null), r || {});
            var o = this.parse(t);
            if (o.execute) {
                o.execute(r);
                if (typeof r.meta.returnValue !== "undefined") return r.meta.returnValue;
                else return r.result;
            } else if (o.apply) {
                o.apply(a, a, n);
                return this.getHyperscriptFeatures(a);
            } else return o.evaluate(r);
            function s() {
                return {};
            }
        }
        processNode(e) {
            var t = this.getScriptSelector();
            if (this.matchesSelector(e, t)) this.initElement(e, e);
            if (e instanceof HTMLScriptElement && e.type === "text/hyperscript") this.initElement(e, document.body);
            if (e.querySelectorAll) this.forEach(e.querySelectorAll(t + ", [type='text/hyperscript']"), (e)=>{
                this.initElement(e, e instanceof HTMLScriptElement && e.type === "text/hyperscript" ? document.body : e);
            });
        }
        initElement(e, t) {
            if (e.closest && e.closest(r.disableSelector)) return;
            var n = this.getInternalData(e);
            if (!n.initialized) {
                var i = this.getScript(e);
                if (i) try {
                    n.initialized = true;
                    n.script = i;
                    const r = this.lexer, s = this.parser;
                    var a = r.tokenize(i);
                    var o = s.parseHyperScript(a);
                    if (!o) return;
                    o.apply(t || e, e);
                    setTimeout(()=>{
                        this.triggerEvent(t || e, "load", {
                            hyperscript: true
                        });
                    }, 1);
                } catch (t) {
                    this.triggerEvent(e, "exception", {
                        error: t
                    });
                    console.error("hyperscript errors were found on the following element:", e, "\n\n", t.message, t.stack);
                }
            }
        }
        internalDataMap = new WeakMap;
        getInternalData(e) {
            var t = this.internalDataMap.get(e);
            if (typeof t === "undefined") this.internalDataMap.set(e, t = {});
            return t;
        }
        typeCheck(e, t, r) {
            if (e == null && r) return true;
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return n === t;
        }
        getElementScope(e) {
            var t = e.meta && e.meta.owner;
            if (t) {
                var r = this.getInternalData(t);
                var n = "elementScope";
                if (e.meta.feature && e.meta.feature.behavior) n = e.meta.feature.behavior + "Scope";
                var i = h(r, n);
                return i;
            } else return {};
        }
        isReservedWord(e) {
            return [
                "meta",
                "it",
                "result",
                "locals",
                "event",
                "target",
                "detail",
                "sender",
                "body"
            ].includes(e);
        }
        isHyperscriptContext(e) {
            return e instanceof f;
        }
        resolveSymbol(t, r, n) {
            if (t === "me" || t === "my" || t === "I") return r.me;
            if (t === "it" || t === "its" || t === "result") return r.result;
            if (t === "you" || t === "your" || t === "yourself") return r.you;
            else {
                if (n === "global") return e[t];
                else if (n === "element") {
                    var i = this.getElementScope(r);
                    return i[t];
                } else if (n === "local") return r.locals[t];
                else {
                    if (r.meta && r.meta.context) {
                        var a = r.meta.context[t];
                        if (typeof a !== "undefined") return a;
                        if (r.meta.context.detail) {
                            a = r.meta.context.detail[t];
                            if (typeof a !== "undefined") return a;
                        }
                    }
                    if (this.isHyperscriptContext(r) && !this.isReservedWord(t)) var o = r.locals[t];
                    else var o = r[t];
                    if (typeof o !== "undefined") return o;
                    else {
                        var i = this.getElementScope(r);
                        o = i[t];
                        if (typeof o !== "undefined") return o;
                        else return e[t];
                    }
                }
            }
        }
        setSymbol(t, r, n, i) {
            if (n === "global") e[t] = i;
            else if (n === "element") {
                var a = this.getElementScope(r);
                a[t] = i;
            } else if (n === "local") r.locals[t] = i;
            else if (this.isHyperscriptContext(r) && !this.isReservedWord(t) && typeof r.locals[t] !== "undefined") r.locals[t] = i;
            else {
                var a = this.getElementScope(r);
                var o = a[t];
                if (typeof o !== "undefined") a[t] = i;
                else if (this.isHyperscriptContext(r) && !this.isReservedWord(t)) r.locals[t] = i;
                else r[t] = i;
            }
        }
        findNext(e, t) {
            if (e) {
                if (e.resolveNext) return e.resolveNext(t);
                else if (e.next) return e.next;
                else return this.findNext(e.parent, t);
            }
        }
        flatGet(e, t, r) {
            if (e != null) {
                var n = r(e, t);
                if (typeof n !== "undefined") return n;
                if (this.shouldAutoIterate(e)) {
                    var i = [];
                    for (var a of e){
                        var o = r(a, t);
                        i.push(o);
                    }
                    return i;
                }
            }
        }
        resolveProperty(e, t) {
            return this.flatGet(e, t, (e, t)=>e[t]);
        }
        resolveAttribute(e, t) {
            return this.flatGet(e, t, (e, t)=>e.getAttribute && e.getAttribute(t));
        }
        resolveStyle(e, t) {
            return this.flatGet(e, t, (e, t)=>e.style && e.style[t]);
        }
        resolveComputedStyle(e, t) {
            return this.flatGet(e, t, (e, t)=>getComputedStyle(e).getPropertyValue(t));
        }
        assignToNamespace(t, r, n, i) {
            let a;
            if (typeof document !== "undefined" && t === document.body) a = e;
            else a = this.getHyperscriptFeatures(t);
            var o;
            while((o = r.shift()) !== undefined){
                var s = a[o];
                if (s == null) {
                    s = {};
                    a[o] = s;
                }
                a = s;
            }
            a[n] = i;
        }
        getHyperTrace(e, t) {
            var r = [];
            var n = e;
            while(n.meta.caller)n = n.meta.caller;
            if (n.meta.traceMap) return n.meta.traceMap.get(t, r);
        }
        registerHyperTrace(e, t) {
            var r = [];
            var n = null;
            while(e != null){
                r.push(e);
                n = e;
                e = e.meta.caller;
            }
            if (n.meta.traceMap == null) n.meta.traceMap = new Map;
            if (!n.meta.traceMap.get(t)) {
                var i = {
                    trace: r,
                    print: function(e) {
                        e = e || console.error;
                        e("hypertrace /// ");
                        var t = 0;
                        for(var n = 0; n < r.length; n++)t = Math.max(t, r[n].meta.feature.displayName.length);
                        for(var n = 0; n < r.length; n++){
                            var i = r[n];
                            e("  ->", i.meta.feature.displayName.padEnd(t + 2), "-", i.meta.owner);
                        }
                    }
                };
                n.meta.traceMap.set(t, i);
            }
        }
        escapeSelector(e) {
            return e.replace(/[:&()\[\]\/]/g, function(e) {
                return "\\" + e;
            });
        }
        nullCheck(e, t) {
            if (e == null) throw new Error("'" + t.sourceFor() + "' is null");
        }
        isEmpty(e) {
            return e == undefined || e.length === 0;
        }
        doesExist(e) {
            if (e == null) return false;
            if (this.shouldAutoIterate(e)) {
                for (const t of e)return true;
                return false;
            }
            return true;
        }
        getRootNode(e) {
            if (e && e instanceof Node) {
                var t = e.getRootNode();
                if (t instanceof Document || t instanceof ShadowRoot) return t;
            }
            return document;
        }
        getEventQueueFor(e, t) {
            let r = this.getInternalData(e);
            var n = r.eventQueues;
            if (n == null) {
                n = new Map;
                r.eventQueues = n;
            }
            var i = n.get(t);
            if (i == null) {
                i = {
                    queue: [],
                    executing: false
                };
                n.set(t, i);
            }
            return i;
        }
        beepValueToConsole(e, t, r) {
            if (this.triggerEvent(e, "hyperscript:beep", {
                element: e,
                expression: t,
                value: r
            })) {
                var n;
                if (r) {
                    if (r instanceof m) n = "ElementCollection";
                    else if (r.constructor) n = r.constructor.name;
                    else n = "unknown";
                } else n = "object (null)";
                var a = r;
                if (n === "String") a = '"' + a + '"';
                else if (r instanceof m) a = Array.from(r);
                console.log("///_ BEEP! The expression (" + i.sourceFor.call(t).replace("beep! ", "") + ") evaluates to:", a, "of type " + n);
            }
        }
        hyperscriptUrl = "document" in e && document.currentScript ? document.currentScript.src : null;
    }
    function s() {
        let e = document.cookie.split("; ").map((e)=>{
            let t = e.split("=");
            return {
                name: t[0],
                value: decodeURIComponent(t[1])
            };
        });
        return e;
    }
    function u(e) {
        document.cookie = e + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    function l() {
        for (const e of s())u(e.name);
    }
    const c = new Proxy({}, {
        get (e, t) {
            if (t === "then" || t === "asyncWrapper") return null;
            else if (t === "length") return s().length;
            else if (t === "clear") return u;
            else if (t === "clearAll") return l;
            else if (typeof t === "string") {
                if (!isNaN(t)) return s()[parseInt(t)];
                else {
                    let e = document.cookie.split("; ").find((e)=>e.startsWith(t + "="))?.split("=")[1];
                    if (e) return decodeURIComponent(e);
                }
            } else if (t === Symbol.iterator) return s()[t];
        },
        set (e, t, r) {
            var n = null;
            if ("string" === typeof r) {
                n = encodeURIComponent(r);
                n += ";samesite=lax";
            } else {
                n = encodeURIComponent(r.value);
                if (r.expires) n += ";expires=" + r.maxAge;
                if (r.maxAge) n += ";max-age=" + r.maxAge;
                if (r.partitioned) n += ";partitioned=" + r.partitioned;
                if (r.path) n += ";path=" + r.path;
                if (r.samesite) n += ";samesite=" + r.path;
                if (r.secure) n += ";secure=" + r.path;
            }
            document.cookie = t + "=" + n;
            return true;
        }
    });
    class f {
        constructor(t, r, n, i, a){
            this.meta = {
                parser: a.parser,
                lexer: a.lexer,
                runtime: a,
                owner: t,
                feature: r,
                iterators: {},
                ctx: this
            };
            this.locals = {
                cookies: c
            };
            this.me = n, this.you = undefined;
            this.result = undefined;
            this.event = i;
            this.target = i ? i.target : null;
            this.detail = i ? i.detail : null;
            this.sender = i ? i.detail ? i.detail.sender : null : null;
            this.body = "document" in e ? document.body : null;
            a.addFeatures(t, this);
        }
    }
    class m {
        constructor(e, t, r){
            this._css = e;
            this.relativeToElement = t;
            this.escape = r;
            this[p] = true;
        }
        get css() {
            if (this.escape) return o.prototype.escapeSelector(this._css);
            else return this._css;
        }
        get className() {
            return this._css.substr(1);
        }
        get id() {
            return this.className();
        }
        contains(e) {
            for (let t of this){
                if (t.contains(e)) return true;
            }
            return false;
        }
        get length() {
            return this.selectMatches().length;
        }
        [Symbol.iterator]() {
            let e = this.selectMatches();
            return e[Symbol.iterator]();
        }
        selectMatches() {
            let e = o.prototype.getRootNode(this.relativeToElement).querySelectorAll(this.css);
            return e;
        }
    }
    const p = Symbol();
    function h(e, t) {
        var r = e[t];
        if (r) return r;
        else {
            var n = {};
            e[t] = n;
            return n;
        }
    }
    function v(e) {
        try {
            return JSON.parse(e);
        } catch (e) {
            d(e);
            return null;
        }
    }
    function d(e) {
        if (console.error) console.error(e);
        else if (console.log) console.log("ERROR: ", e);
    }
    function E(e, t) {
        return new (e.bind.apply(e, [
            e
        ].concat(t)));
    }
    function T(t) {
        t.addLeafExpression("parenthesized", function(e, t, r) {
            if (r.matchOpToken("(")) {
                var n = r.clearFollows();
                try {
                    var i = e.requireElement("expression", r);
                } finally{
                    r.restoreFollows(n);
                }
                r.requireOpToken(")");
                return i;
            }
        });
        t.addLeafExpression("string", function(e, t, r) {
            var i = r.matchTokenType("STRING");
            if (!i) return;
            var a = i.value;
            var o;
            if (i.template) {
                var s = n.tokenize(a, true);
                o = e.parseStringTemplate(s);
            } else o = [];
            return {
                type: "string",
                token: i,
                args: o,
                op: function(e) {
                    var t = "";
                    for(var r = 1; r < arguments.length; r++){
                        var n = arguments[r];
                        if (n !== undefined) t += n;
                    }
                    return t;
                },
                evaluate: function(e) {
                    if (o.length === 0) return a;
                    else return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("nakedString", function(e, t, r) {
            if (r.hasMore()) {
                var n = r.consumeUntilWhitespace();
                r.matchTokenType("WHITESPACE");
                return {
                    type: "nakedString",
                    tokens: n,
                    evaluate: function(e) {
                        return n.map(function(e) {
                            return e.value;
                        }).join("");
                    }
                };
            }
        });
        t.addLeafExpression("number", function(e, t, r) {
            var n = r.matchTokenType("NUMBER");
            if (!n) return;
            var i = n;
            var a = parseFloat(n.value);
            return {
                type: "number",
                value: a,
                numberToken: i,
                evaluate: function() {
                    return a;
                }
            };
        });
        t.addLeafExpression("idRef", function(e, t, r) {
            var i = r.matchTokenType("ID_REF");
            if (!i) return;
            if (!i.value) return;
            if (i.template) {
                var a = i.value.substring(2);
                var o = n.tokenize(a);
                var s = e.requireElement("expression", o);
                return {
                    type: "idRefTemplate",
                    args: [
                        s
                    ],
                    op: function(e, r) {
                        return t.getRootNode(e.me).getElementById(r);
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            } else {
                const e = i.value.substring(1);
                return {
                    type: "idRef",
                    css: i.value,
                    value: e,
                    evaluate: function(r) {
                        return t.getRootNode(r.me).getElementById(e);
                    }
                };
            }
        });
        t.addLeafExpression("classRef", function(e, t, r) {
            var i = r.matchTokenType("CLASS_REF");
            if (!i) return;
            if (!i.value) return;
            if (i.template) {
                var a = i.value.substring(2);
                var o = n.tokenize(a);
                var s = e.requireElement("expression", o);
                return {
                    type: "classRefTemplate",
                    args: [
                        s
                    ],
                    op: function(e, t) {
                        return new m("." + t, e.me, true);
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            } else {
                const e = i.value;
                return {
                    type: "classRef",
                    css: e,
                    evaluate: function(t) {
                        return new m(e, t.me, true);
                    }
                };
            }
        });
        class r extends m {
            constructor(e, t, r){
                super(e, t);
                this.templateParts = r;
                this.elements = r.filter((e)=>e instanceof Element);
            }
            get css() {
                let e = "", t = 0;
                for (const r of this.templateParts)if (r instanceof Element) e += "[data-hs-query-id='" + t++ + "']";
                else e += r;
                return e;
            }
            [Symbol.iterator]() {
                this.elements.forEach((e, t)=>e.dataset.hsQueryId = t);
                const e = super[Symbol.iterator]();
                this.elements.forEach((e)=>e.removeAttribute("data-hs-query-id"));
                return e;
            }
        }
        t.addLeafExpression("queryRef", function(e, t, i) {
            var a = i.matchOpToken("<");
            if (!a) return;
            var o = i.consumeUntil("/");
            i.requireOpToken("/");
            i.requireOpToken(">");
            var s = o.map(function(e) {
                if (e.type === "STRING") return '"' + e.value + '"';
                else return e.value;
            }).join("");
            var u, l, c;
            if (/\$[^=]/.test(s)) {
                u = true;
                l = n.tokenize(s, true);
                c = e.parseStringTemplate(l);
            }
            return {
                type: "queryRef",
                css: s,
                args: c,
                op: function(e, ...t) {
                    if (u) return new r(s, e.me, t);
                    else return new m(s, e.me);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addLeafExpression("attributeRef", function(e, t, r) {
            var n = r.matchTokenType("ATTRIBUTE_REF");
            if (!n) return;
            if (!n.value) return;
            var i = n.value;
            if (i.indexOf("[") === 0) var a = i.substring(2, i.length - 1);
            else var a = i.substring(1);
            var o = "[" + a + "]";
            var s = a.split("=");
            var u = s[0];
            var l = s[1];
            if (l) {
                if (l.indexOf('"') === 0) l = l.substring(1, l.length - 1);
            }
            return {
                type: "attributeRef",
                name: u,
                css: o,
                value: l,
                op: function(e) {
                    var t = e.you || e.me;
                    if (t) return t.getAttribute(u);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addLeafExpression("styleRef", function(e, t, r) {
            var n = r.matchTokenType("STYLE_REF");
            if (!n) return;
            if (!n.value) return;
            var i = n.value.substr(1);
            if (i.startsWith("computed-")) {
                i = i.substr(9);
                return {
                    type: "computedStyleRef",
                    name: i,
                    op: function(e) {
                        var r = e.you || e.me;
                        if (r) return t.resolveComputedStyle(r, i);
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            } else return {
                type: "styleRef",
                name: i,
                op: function(e) {
                    var r = e.you || e.me;
                    if (r) return t.resolveStyle(r, i);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("objectKey", function(e, t, r) {
            var n;
            if (n = r.matchTokenType("STRING")) return {
                type: "objectKey",
                key: n.value,
                evaluate: function() {
                    return n.value;
                }
            };
            else if (r.matchOpToken("[")) {
                var i = e.parseElement("expression", r);
                r.requireOpToken("]");
                return {
                    type: "objectKey",
                    expr: i,
                    args: [
                        i
                    ],
                    op: function(e, t) {
                        return t;
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            } else {
                var a = "";
                do {
                    n = r.matchTokenType("IDENTIFIER") || r.matchOpToken("-");
                    if (n) a += n.value;
                }while (n);
                return {
                    type: "objectKey",
                    key: a,
                    evaluate: function() {
                        return a;
                    }
                };
            }
        });
        t.addLeafExpression("objectLiteral", function(e, t, r) {
            if (!r.matchOpToken("{")) return;
            var n = [];
            var i = [];
            if (!r.matchOpToken("}")) {
                do {
                    var a = e.requireElement("objectKey", r);
                    r.requireOpToken(":");
                    var o = e.requireElement("expression", r);
                    i.push(o);
                    n.push(a);
                }while (r.matchOpToken(",") && !r.peekToken("}", 0, "R_BRACE"));
                r.requireOpToken("}");
            }
            return {
                type: "objectLiteral",
                args: [
                    n,
                    i
                ],
                op: function(e, t, r) {
                    var n = {};
                    for(var i = 0; i < t.length; i++)n[t[i]] = r[i];
                    return n;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("nakedNamedArgumentList", function(e, t, r) {
            var n = [];
            var i = [];
            if (r.currentToken().type === "IDENTIFIER") do {
                var a = r.requireTokenType("IDENTIFIER");
                r.requireOpToken(":");
                var o = e.requireElement("expression", r);
                i.push(o);
                n.push({
                    name: a,
                    value: o
                });
            }while (r.matchOpToken(","));
            return {
                type: "namedArgumentList",
                fields: n,
                args: [
                    i
                ],
                op: function(e, t) {
                    var r = {
                        _namedArgList_: true
                    };
                    for(var i = 0; i < t.length; i++){
                        var a = n[i];
                        r[a.name.value] = t[i];
                    }
                    return r;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("namedArgumentList", function(e, t, r) {
            if (!r.matchOpToken("(")) return;
            var n = e.requireElement("nakedNamedArgumentList", r);
            r.requireOpToken(")");
            return n;
        });
        t.addGrammarElement("symbol", function(e, t, r) {
            var n = "default";
            if (r.matchToken("global")) n = "global";
            else if (r.matchToken("element") || r.matchToken("module")) {
                n = "element";
                if (r.matchOpToken("'")) r.requireToken("s");
            } else if (r.matchToken("local")) n = "local";
            let i = r.matchOpToken(":");
            let a = r.matchTokenType("IDENTIFIER");
            if (a && a.value) {
                var o = a.value;
                if (i) o = ":" + o;
                if (n === "default") {
                    if (o.indexOf("$") === 0) n = "global";
                    if (o.indexOf(":") === 0) n = "element";
                }
                return {
                    type: "symbol",
                    token: a,
                    scope: n,
                    name: o,
                    evaluate: function(e) {
                        return t.resolveSymbol(o, e, n);
                    }
                };
            }
        });
        t.addGrammarElement("implicitMeTarget", function(e, t, r) {
            return {
                type: "implicitMeTarget",
                evaluate: function(e) {
                    return e.you || e.me;
                }
            };
        });
        t.addLeafExpression("boolean", function(e, t, r) {
            var n = r.matchToken("true") || r.matchToken("false");
            if (!n) return;
            const i = n.value === "true";
            return {
                type: "boolean",
                evaluate: function(e) {
                    return i;
                }
            };
        });
        t.addLeafExpression("null", function(e, t, r) {
            if (r.matchToken("null")) return {
                type: "null",
                evaluate: function(e) {
                    return null;
                }
            };
        });
        t.addLeafExpression("arrayLiteral", function(e, t, r) {
            if (!r.matchOpToken("[")) return;
            var n = [];
            if (!r.matchOpToken("]")) {
                do {
                    var i = e.requireElement("expression", r);
                    n.push(i);
                }while (r.matchOpToken(","));
                r.requireOpToken("]");
            }
            return {
                type: "arrayLiteral",
                values: n,
                args: [
                    n
                ],
                op: function(e, t) {
                    return t;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addLeafExpression("blockLiteral", function(e, t, r) {
            if (!r.matchOpToken("\\")) return;
            var n = [];
            var i = r.matchTokenType("IDENTIFIER");
            if (i) {
                n.push(i);
                while(r.matchOpToken(","))n.push(r.requireTokenType("IDENTIFIER"));
            }
            r.requireOpToken("-");
            r.requireOpToken(">");
            var a = e.requireElement("expression", r);
            return {
                type: "blockLiteral",
                args: n,
                expr: a,
                evaluate: function(e) {
                    var t = function() {
                        for(var t = 0; t < n.length; t++)e.locals[n[t].value] = arguments[t];
                        return a.evaluate(e);
                    };
                    return t;
                }
            };
        });
        t.addIndirectExpression("propertyAccess", function(e, t, r, n) {
            if (!r.matchOpToken(".")) return;
            var i = r.requireTokenType("IDENTIFIER");
            var a = {
                type: "propertyAccess",
                root: n,
                prop: i,
                args: [
                    n
                ],
                op: function(e, r) {
                    var n = t.resolveProperty(r, i.value);
                    return n;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return e.parseElement("indirectExpression", r, a);
        });
        t.addIndirectExpression("of", function(e, t, r, n) {
            if (!r.matchToken("of")) return;
            var i = e.requireElement("unaryExpression", r);
            var a = null;
            var o = n;
            while(o.root){
                a = o;
                o = o.root;
            }
            if (o.type !== "symbol" && o.type !== "attributeRef" && o.type !== "styleRef" && o.type !== "computedStyleRef") e.raiseParseError(r, "Cannot take a property of a non-symbol: " + o.type);
            var s = o.type === "attributeRef";
            var u = o.type === "styleRef" || o.type === "computedStyleRef";
            if (s || u) var l = o;
            var c = o.name;
            var f = {
                type: "ofExpression",
                prop: o.token,
                root: i,
                attribute: l,
                expression: n,
                args: [
                    i
                ],
                op: function(e, r) {
                    if (s) return t.resolveAttribute(r, c);
                    else if (u) {
                        if (o.type === "computedStyleRef") return t.resolveComputedStyle(r, c);
                        else return t.resolveStyle(r, c);
                    } else return t.resolveProperty(r, c);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            if (o.type === "attributeRef") f.attribute = o;
            if (a) {
                a.root = f;
                a.args = [
                    f
                ];
            } else n = f;
            return e.parseElement("indirectExpression", r, n);
        });
        t.addIndirectExpression("possessive", function(e, t, r, n) {
            if (e.possessivesDisabled) return;
            var i = r.matchOpToken("'");
            if (i || n.type === "symbol" && (n.name === "my" || n.name === "its" || n.name === "your") && (r.currentToken().type === "IDENTIFIER" || r.currentToken().type === "ATTRIBUTE_REF" || r.currentToken().type === "STYLE_REF")) {
                if (i) r.requireToken("s");
                var a, o, s;
                a = e.parseElement("attributeRef", r);
                if (a == null) {
                    o = e.parseElement("styleRef", r);
                    if (o == null) s = r.requireTokenType("IDENTIFIER");
                }
                var u = {
                    type: "possessive",
                    root: n,
                    attribute: a || o,
                    prop: s,
                    args: [
                        n
                    ],
                    op: function(e, r) {
                        if (a) var n = t.resolveAttribute(r, a.name);
                        else if (o) {
                            var n;
                            if (o.type === "computedStyleRef") n = t.resolveComputedStyle(r, o["name"]);
                            else n = t.resolveStyle(r, o["name"]);
                        } else var n = t.resolveProperty(r, s.value);
                        return n;
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
                return e.parseElement("indirectExpression", r, u);
            }
        });
        t.addIndirectExpression("inExpression", function(e, t, r, n) {
            if (!r.matchToken("in")) return;
            var i = e.requireElement("unaryExpression", r);
            var a = {
                type: "inExpression",
                root: n,
                args: [
                    n,
                    i
                ],
                op: function(e, r, n) {
                    var i = [];
                    if (r.css) t.implicitLoop(n, function(e) {
                        var t = e.querySelectorAll(r.css);
                        for(var n = 0; n < t.length; n++)i.push(t[n]);
                    });
                    else if (r instanceof Element) {
                        var a = false;
                        t.implicitLoop(n, function(e) {
                            if (e.contains(r)) a = true;
                        });
                        if (a) return r;
                    } else t.implicitLoop(r, function(e) {
                        t.implicitLoop(n, function(t) {
                            if (e === t) i.push(e);
                        });
                    });
                    return i;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return e.parseElement("indirectExpression", r, a);
        });
        t.addIndirectExpression("asExpression", function(e, t, r, n) {
            if (!r.matchToken("as")) return;
            r.matchToken("a") || r.matchToken("an");
            var i = e.requireElement("dotOrColonPath", r).evaluate();
            var a = {
                type: "asExpression",
                root: n,
                args: [
                    n
                ],
                op: function(e, r) {
                    return t.convertValue(r, i);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return e.parseElement("indirectExpression", r, a);
        });
        t.addIndirectExpression("functionCall", function(e, t, r, n) {
            if (!r.matchOpToken("(")) return;
            var i = [];
            if (!r.matchOpToken(")")) {
                do i.push(e.requireElement("expression", r));
                while (r.matchOpToken(","));
                r.requireOpToken(")");
            }
            if (n.root) var a = {
                type: "functionCall",
                root: n,
                argExressions: i,
                args: [
                    n.root,
                    i
                ],
                op: function(e, r, i) {
                    t.nullCheck(r, n.root);
                    var a = r[n.prop.value];
                    t.nullCheck(a, n);
                    if (a.hyperfunc) i.push(e);
                    return a.apply(r, i);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            else var a = {
                type: "functionCall",
                root: n,
                argExressions: i,
                args: [
                    n,
                    i
                ],
                op: function(e, r, i) {
                    t.nullCheck(r, n);
                    if (r.hyperfunc) i.push(e);
                    var a = r.apply(null, i);
                    return a;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return e.parseElement("indirectExpression", r, a);
        });
        t.addIndirectExpression("attributeRefAccess", function(e, t, r, n) {
            var i = e.parseElement("attributeRef", r);
            if (!i) return;
            var a = {
                type: "attributeRefAccess",
                root: n,
                attribute: i,
                args: [
                    n
                ],
                op: function(e, r) {
                    var n = t.resolveAttribute(r, i.name);
                    return n;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return a;
        });
        t.addIndirectExpression("arrayIndex", function(e, t, r, n) {
            if (!r.matchOpToken("[")) return;
            var i = false;
            var a = false;
            var o = null;
            var s = null;
            if (r.matchOpToken("..")) {
                i = true;
                o = e.requireElement("expression", r);
            } else {
                o = e.requireElement("expression", r);
                if (r.matchOpToken("..")) {
                    a = true;
                    var u = r.currentToken();
                    if (u.type !== "R_BRACKET") s = e.parseElement("expression", r);
                }
            }
            r.requireOpToken("]");
            var l = {
                type: "arrayIndex",
                root: n,
                prop: o,
                firstIndex: o,
                secondIndex: s,
                args: [
                    n,
                    o,
                    s
                ],
                op: function(e, t, r, n) {
                    if (t == null) return null;
                    if (i) {
                        if (r < 0) r = t.length + r;
                        return t.slice(0, r + 1);
                    } else if (a) {
                        if (n != null) {
                            if (n < 0) n = t.length + n;
                            return t.slice(r, n + 1);
                        } else return t.slice(r);
                    } else return t[r];
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return e.parseElement("indirectExpression", r, l);
        });
        var a = [
            "em",
            "ex",
            "cap",
            "ch",
            "ic",
            "rem",
            "lh",
            "rlh",
            "vw",
            "vh",
            "vi",
            "vb",
            "vmin",
            "vmax",
            "cm",
            "mm",
            "Q",
            "pc",
            "pt",
            "px"
        ];
        t.addGrammarElement("postfixExpression", function(e, t, r) {
            var n = e.parseElement("negativeNumber", r);
            let i = r.matchAnyToken.apply(r, a) || r.matchOpToken("%");
            if (i) return {
                type: "stringPostfix",
                postfix: i.value,
                args: [
                    n
                ],
                op: function(e, t) {
                    return "" + t + i.value;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            var o = null;
            if (r.matchToken("s") || r.matchToken("seconds")) o = 1e3;
            else if (r.matchToken("ms") || r.matchToken("milliseconds")) o = 1;
            if (o) return {
                type: "timeExpression",
                time: n,
                factor: o,
                args: [
                    n
                ],
                op: function(e, t) {
                    return t * o;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            if (r.matchOpToken(":")) {
                var s = r.requireTokenType("IDENTIFIER");
                if (!s.value) return;
                var u = !r.matchOpToken("!");
                return {
                    type: "typeCheck",
                    typeName: s,
                    nullOk: u,
                    args: [
                        n
                    ],
                    op: function(e, r) {
                        var n = t.typeCheck(r, this.typeName.value, u);
                        if (n) return r;
                        else throw new Error("Typecheck failed!  Expected: " + s.value);
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            } else return n;
        });
        t.addGrammarElement("logicalNot", function(e, t, r) {
            if (!r.matchToken("not")) return;
            var n = e.requireElement("unaryExpression", r);
            return {
                type: "logicalNot",
                root: n,
                args: [
                    n
                ],
                op: function(e, t) {
                    return !t;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("noExpression", function(e, t, r) {
            if (!r.matchToken("no")) return;
            var n = e.requireElement("unaryExpression", r);
            return {
                type: "noExpression",
                root: n,
                args: [
                    n
                ],
                op: function(e, r) {
                    return t.isEmpty(r);
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addLeafExpression("some", function(e, t, r) {
            if (!r.matchToken("some")) return;
            var n = e.requireElement("expression", r);
            return {
                type: "noExpression",
                root: n,
                args: [
                    n
                ],
                op: function(e, r) {
                    return !t.isEmpty(r);
                },
                evaluate (e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("negativeNumber", function(e, t, r) {
            if (r.matchOpToken("-")) {
                var n = e.requireElement("negativeNumber", r);
                return {
                    type: "negativeNumber",
                    root: n,
                    args: [
                        n
                    ],
                    op: function(e, t) {
                        return -1 * t;
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            } else return e.requireElement("primaryExpression", r);
        });
        t.addGrammarElement("unaryExpression", function(e, t, r) {
            r.matchToken("the");
            return e.parseAnyOf([
                "beepExpression",
                "logicalNot",
                "relativePositionalExpression",
                "positionalExpression",
                "noExpression",
                "postfixExpression"
            ], r);
        });
        t.addGrammarElement("beepExpression", function(e, t, r) {
            if (!r.matchToken("beep!")) return;
            var n = e.parseElement("unaryExpression", r);
            if (n) {
                n["booped"] = true;
                var i = n.evaluate;
                n.evaluate = function(e) {
                    let r = i.apply(n, arguments);
                    let a = e.me;
                    t.beepValueToConsole(a, n, r);
                    return r;
                };
                return n;
            }
        });
        var s = function(e, t, r, n) {
            var i = t.querySelectorAll(r);
            for(var a = 0; a < i.length; a++){
                var o = i[a];
                if (o.compareDocumentPosition(e) === Node.DOCUMENT_POSITION_PRECEDING) return o;
            }
            if (n) return i[0];
        };
        var u = function(e, t, r, n) {
            var i = t.querySelectorAll(r);
            for(var a = i.length - 1; a >= 0; a--){
                var o = i[a];
                if (o.compareDocumentPosition(e) === Node.DOCUMENT_POSITION_FOLLOWING) return o;
            }
            if (n) return i[i.length - 1];
        };
        var l = function(e, t, r, n) {
            var i = [];
            o.prototype.forEach(t, function(t) {
                if (t.matches(r) || t === e) i.push(t);
            });
            for(var a = 0; a < i.length - 1; a++){
                var s = i[a];
                if (s === e) return i[a + 1];
            }
            if (n) {
                var u = i[0];
                if (u && u.matches(r)) return u;
            }
        };
        var c = function(e, t, r, n) {
            return l(e, Array.from(t).reverse(), r, n);
        };
        t.addGrammarElement("relativePositionalExpression", function(e, t, r) {
            var n = r.matchAnyToken("next", "previous");
            if (!n) return;
            var a = n.value === "next";
            var o = e.parseElement("expression", r);
            if (r.matchToken("from")) {
                r.pushFollow("in");
                try {
                    var f = e.requireElement("unaryExpression", r);
                } finally{
                    r.popFollow();
                }
            } else var f = e.requireElement("implicitMeTarget", r);
            var m = false;
            var p;
            if (r.matchToken("in")) {
                m = true;
                var h = e.requireElement("unaryExpression", r);
            } else if (r.matchToken("within")) p = e.requireElement("unaryExpression", r);
            else p = document.body;
            var v = false;
            if (r.matchToken("with")) {
                r.requireToken("wrapping");
                v = true;
            }
            return {
                type: "relativePositionalExpression",
                from: f,
                forwardSearch: a,
                inSearch: m,
                wrapping: v,
                inElt: h,
                withinElt: p,
                operator: n.value,
                args: [
                    o,
                    f,
                    h,
                    p
                ],
                op: function(e, t, r, n, f) {
                    var p = t.css;
                    if (p == null) throw "Expected a CSS value to be returned by " + i.sourceFor.apply(o);
                    if (m) {
                        if (n) {
                            if (a) return l(r, n, p, v);
                            else return c(r, n, p, v);
                        }
                    } else if (f) {
                        if (a) return s(r, f, p, v);
                        else return u(r, f, p, v);
                    }
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("positionalExpression", function(e, t, r) {
            var n = r.matchAnyToken("first", "last", "random");
            if (!n) return;
            r.matchAnyToken("in", "from", "of");
            var i = e.requireElement("unaryExpression", r);
            const a = n.value;
            return {
                type: "positionalExpression",
                rhs: i,
                operator: n.value,
                args: [
                    i
                ],
                op: function(e, t) {
                    if (t && !Array.isArray(t)) {
                        if (t.children) t = t.children;
                        else t = Array.from(t);
                    }
                    if (t) {
                        if (a === "first") return t[0];
                        else if (a === "last") return t[t.length - 1];
                        else if (a === "random") return t[Math.floor(Math.random() * t.length)];
                    }
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        t.addGrammarElement("mathOperator", function(e, t, r) {
            var n = e.parseElement("unaryExpression", r);
            var i, a = null;
            i = r.matchAnyOpToken("+", "-", "*", "/") || r.matchToken("mod");
            while(i){
                a = a || i;
                var o = i.value;
                if (a.value !== o) e.raiseParseError(r, "You must parenthesize math operations with different operators");
                var s = e.parseElement("unaryExpression", r);
                n = {
                    type: "mathOperator",
                    lhs: n,
                    rhs: s,
                    operator: o,
                    args: [
                        n,
                        s
                    ],
                    op: function(e, t, r) {
                        if (o === "+") return t + r;
                        else if (o === "-") return t - r;
                        else if (o === "*") return t * r;
                        else if (o === "/") return t / r;
                        else if (o === "mod") return t % r;
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
                i = r.matchAnyOpToken("+", "-", "*", "/") || r.matchToken("mod");
            }
            return n;
        });
        t.addGrammarElement("mathExpression", function(e, t, r) {
            return e.parseAnyOf([
                "mathOperator",
                "unaryExpression"
            ], r);
        });
        function f(e, t, r) {
            if (t["contains"]) return t.contains(r);
            else if (t["includes"]) return t.includes(r);
            else throw Error("The value of " + e.sourceFor() + " does not have a contains or includes method on it");
        }
        function p(e, t, r) {
            if (t["match"]) return !!t.match(r);
            else if (t["matches"]) return t.matches(r);
            else throw Error("The value of " + e.sourceFor() + " does not have a match or matches method on it");
        }
        t.addGrammarElement("comparisonOperator", function(e, t, r) {
            var n = e.parseElement("mathExpression", r);
            var i = r.matchAnyOpToken("<", ">", "<=", ">=", "==", "===", "!=", "!==");
            var a = i ? i.value : null;
            var o = true;
            var s = false;
            if (a == null) {
                if (r.matchToken("is") || r.matchToken("am")) {
                    if (r.matchToken("not")) {
                        if (r.matchToken("in")) a = "not in";
                        else if (r.matchToken("a") || r.matchToken("an")) {
                            a = "not a";
                            s = true;
                        } else if (r.matchToken("empty")) {
                            a = "not empty";
                            o = false;
                        } else {
                            if (r.matchToken("really")) a = "!==";
                            else a = "!=";
                            if (r.matchToken("equal")) r.matchToken("to");
                        }
                    } else if (r.matchToken("in")) a = "in";
                    else if (r.matchToken("a") || r.matchToken("an")) {
                        a = "a";
                        s = true;
                    } else if (r.matchToken("empty")) {
                        a = "empty";
                        o = false;
                    } else if (r.matchToken("less")) {
                        r.requireToken("than");
                        if (r.matchToken("or")) {
                            r.requireToken("equal");
                            r.requireToken("to");
                            a = "<=";
                        } else a = "<";
                    } else if (r.matchToken("greater")) {
                        r.requireToken("than");
                        if (r.matchToken("or")) {
                            r.requireToken("equal");
                            r.requireToken("to");
                            a = ">=";
                        } else a = ">";
                    } else {
                        if (r.matchToken("really")) a = "===";
                        else a = "==";
                        if (r.matchToken("equal")) r.matchToken("to");
                    }
                } else if (r.matchToken("equals")) a = "==";
                else if (r.matchToken("really")) {
                    r.requireToken("equals");
                    a = "===";
                } else if (r.matchToken("exist") || r.matchToken("exists")) {
                    a = "exist";
                    o = false;
                } else if (r.matchToken("matches") || r.matchToken("match")) a = "match";
                else if (r.matchToken("contains") || r.matchToken("contain")) a = "contain";
                else if (r.matchToken("includes") || r.matchToken("include")) a = "include";
                else if (r.matchToken("do") || r.matchToken("does")) {
                    r.requireToken("not");
                    if (r.matchToken("matches") || r.matchToken("match")) a = "not match";
                    else if (r.matchToken("contains") || r.matchToken("contain")) a = "not contain";
                    else if (r.matchToken("exist") || r.matchToken("exist")) {
                        a = "not exist";
                        o = false;
                    } else if (r.matchToken("include")) a = "not include";
                    else e.raiseParseError(r, "Expected matches or contains");
                }
            }
            if (a) {
                var u, l, c;
                if (s) {
                    u = r.requireTokenType("IDENTIFIER");
                    l = !r.matchOpToken("!");
                } else if (o) {
                    c = e.requireElement("mathExpression", r);
                    if (a === "match" || a === "not match") c = c.css ? c.css : c;
                }
                var m = n;
                n = {
                    type: "comparisonOperator",
                    operator: a,
                    typeName: u,
                    nullOk: l,
                    lhs: n,
                    rhs: c,
                    args: [
                        n,
                        c
                    ],
                    op: function(e, r, n) {
                        if (a === "==") return r == n;
                        else if (a === "!=") return r != n;
                        if (a === "===") return r === n;
                        else if (a === "!==") return r !== n;
                        if (a === "match") return r != null && p(m, r, n);
                        if (a === "not match") return r == null || !p(m, r, n);
                        if (a === "in") return n != null && f(c, n, r);
                        if (a === "not in") return n == null || !f(c, n, r);
                        if (a === "contain") return r != null && f(m, r, n);
                        if (a === "not contain") return r == null || !f(m, r, n);
                        if (a === "include") return r != null && f(m, r, n);
                        if (a === "not include") return r == null || !f(m, r, n);
                        if (a === "===") return r === n;
                        else if (a === "!==") return r !== n;
                        else if (a === "<") return r < n;
                        else if (a === ">") return r > n;
                        else if (a === "<=") return r <= n;
                        else if (a === ">=") return r >= n;
                        else if (a === "empty") return t.isEmpty(r);
                        else if (a === "not empty") return !t.isEmpty(r);
                        else if (a === "exist") return t.doesExist(r);
                        else if (a === "not exist") return !t.doesExist(r);
                        else if (a === "a") return t.typeCheck(r, u.value, l);
                        else if (a === "not a") return !t.typeCheck(r, u.value, l);
                        else throw "Unknown comparison : " + a;
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
            }
            return n;
        });
        t.addGrammarElement("comparisonExpression", function(e, t, r) {
            return e.parseAnyOf([
                "comparisonOperator",
                "mathExpression"
            ], r);
        });
        t.addGrammarElement("logicalOperator", function(e, t, r) {
            var n = e.parseElement("comparisonExpression", r);
            var i, a = null;
            i = r.matchToken("and") || r.matchToken("or");
            while(i){
                a = a || i;
                if (a.value !== i.value) e.raiseParseError(r, "You must parenthesize logical operations with different operators");
                var o = e.requireElement("comparisonExpression", r);
                const s = i.value;
                n = {
                    type: "logicalOperator",
                    operator: s,
                    lhs: n,
                    rhs: o,
                    args: [
                        n,
                        o
                    ],
                    op: function(e, t, r) {
                        if (s === "and") return t && r;
                        else return t || r;
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e, s === "or");
                    }
                };
                i = r.matchToken("and") || r.matchToken("or");
            }
            return n;
        });
        t.addGrammarElement("logicalExpression", function(e, t, r) {
            return e.parseAnyOf([
                "logicalOperator",
                "mathExpression"
            ], r);
        });
        t.addGrammarElement("asyncExpression", function(e, t, r) {
            if (r.matchToken("async")) {
                var n = e.requireElement("logicalExpression", r);
                var i = {
                    type: "asyncExpression",
                    value: n,
                    evaluate: function(e) {
                        return {
                            asyncWrapper: true,
                            value: this.value.evaluate(e)
                        };
                    }
                };
                return i;
            } else return e.parseElement("logicalExpression", r);
        });
        t.addGrammarElement("expression", function(e, t, r) {
            r.matchToken("the");
            return e.parseElement("asyncExpression", r);
        });
        t.addGrammarElement("assignableExpression", function(e, t, r) {
            r.matchToken("the");
            var n = e.parseElement("primaryExpression", r);
            if (n && (n.type === "symbol" || n.type === "ofExpression" || n.type === "propertyAccess" || n.type === "attributeRefAccess" || n.type === "attributeRef" || n.type === "styleRef" || n.type === "arrayIndex" || n.type === "possessive")) return n;
            else e.raiseParseError(r, "A target expression must be writable.  The expression type '" + (n && n.type) + "' is not.");
            return n;
        });
        t.addGrammarElement("hyperscript", function(e, t, r) {
            var n = [];
            if (r.hasMore()) while(e.featureStart(r.currentToken()) || r.currentToken().value === "("){
                var i = e.requireElement("feature", r);
                n.push(i);
                r.matchToken("end");
            }
            return {
                type: "hyperscript",
                features: n,
                apply: function(e, t, r) {
                    for (const i of n)i.install(e, t, r);
                }
            };
        });
        var v = function(e) {
            var t = [];
            if (e.token(0).value === "(" && (e.token(1).value === ")" || e.token(2).value === "," || e.token(2).value === ")")) {
                e.matchOpToken("(");
                do t.push(e.requireTokenType("IDENTIFIER"));
                while (e.matchOpToken(","));
                e.requireOpToken(")");
            }
            return t;
        };
        t.addFeature("on", function(e, t, r) {
            if (!r.matchToken("on")) return;
            var n = false;
            if (r.matchToken("every")) n = true;
            var i = [];
            var a = null;
            do {
                var o = e.requireElement("eventName", r, "Expected event name");
                var s = o.evaluate();
                if (a) a = a + " or " + s;
                else a = "on " + s;
                var u = v(r);
                var l = null;
                if (r.matchOpToken("[")) {
                    l = e.requireElement("expression", r);
                    r.requireOpToken("]");
                }
                var c, f, m;
                if (r.currentToken().type === "NUMBER") {
                    var p = r.consumeToken();
                    if (!p.value) return;
                    c = parseInt(p.value);
                    if (r.matchToken("to")) {
                        var h = r.consumeToken();
                        if (!h.value) return;
                        f = parseInt(h.value);
                    } else if (r.matchToken("and")) {
                        m = true;
                        r.requireToken("on");
                    }
                }
                var d, E;
                if (s === "intersection") {
                    d = {};
                    if (r.matchToken("with")) d["with"] = e.requireElement("expression", r).evaluate();
                    if (r.matchToken("having")) do {
                        if (r.matchToken("margin")) d["rootMargin"] = e.requireElement("stringLike", r).evaluate();
                        else if (r.matchToken("threshold")) d["threshold"] = e.requireElement("expression", r).evaluate();
                        else e.raiseParseError(r, "Unknown intersection config specification");
                    }while (r.matchToken("and"));
                } else if (s === "mutation") {
                    E = {};
                    if (r.matchToken("of")) do {
                        if (r.matchToken("anything")) {
                            E["attributes"] = true;
                            E["subtree"] = true;
                            E["characterData"] = true;
                            E["childList"] = true;
                        } else if (r.matchToken("childList")) E["childList"] = true;
                        else if (r.matchToken("attributes")) {
                            E["attributes"] = true;
                            E["attributeOldValue"] = true;
                        } else if (r.matchToken("subtree")) E["subtree"] = true;
                        else if (r.matchToken("characterData")) {
                            E["characterData"] = true;
                            E["characterDataOldValue"] = true;
                        } else if (r.currentToken().type === "ATTRIBUTE_REF") {
                            var T = r.consumeToken();
                            if (E["attributeFilter"] == null) E["attributeFilter"] = [];
                            if (T.value.indexOf("@") == 0) E["attributeFilter"].push(T.value.substring(1));
                            else e.raiseParseError(r, "Only shorthand attribute references are allowed here");
                        } else e.raiseParseError(r, "Unknown mutation config specification");
                    }while (r.matchToken("or"));
                    else {
                        E["attributes"] = true;
                        E["characterData"] = true;
                        E["childList"] = true;
                    }
                }
                var y = null;
                var k = false;
                if (r.matchToken("from")) {
                    if (r.matchToken("elsewhere")) k = true;
                    else {
                        r.pushFollow("or");
                        try {
                            y = e.requireElement("expression", r);
                        } finally{
                            r.popFollow();
                        }
                        if (!y) e.raiseParseError(r, 'Expected either target value or "elsewhere".');
                    }
                }
                if (y === null && k === false && r.matchToken("elsewhere")) k = true;
                if (r.matchToken("in")) var x = e.parseElement("unaryExpression", r);
                if (r.matchToken("debounced")) {
                    r.requireToken("at");
                    var g = e.requireElement("unaryExpression", r);
                    var b = g.evaluate({});
                } else if (r.matchToken("throttled")) {
                    r.requireToken("at");
                    var g = e.requireElement("unaryExpression", r);
                    var w = g.evaluate({});
                }
                i.push({
                    execCount: 0,
                    every: n,
                    on: s,
                    args: u,
                    filter: l,
                    from: y,
                    inExpr: x,
                    elsewhere: k,
                    startCount: c,
                    endCount: f,
                    unbounded: m,
                    debounceTime: b,
                    throttleTime: w,
                    mutationSpec: E,
                    intersectionSpec: d,
                    debounced: undefined,
                    lastExec: undefined
                });
            }while (r.matchToken("or"));
            var S = true;
            if (!n) {
                if (r.matchToken("queue")) {
                    if (r.matchToken("all")) {
                        var N = true;
                        var S = false;
                    } else if (r.matchToken("first")) var q = true;
                    else if (r.matchToken("none")) var I = true;
                    else r.requireToken("last");
                }
            }
            var C = e.requireElement("commandList", r);
            e.ensureTerminated(C);
            var R, A;
            if (r.matchToken("catch")) {
                R = r.requireTokenType("IDENTIFIER").value;
                A = e.requireElement("commandList", r);
                e.ensureTerminated(A);
            }
            if (r.matchToken("finally")) {
                var L = e.requireElement("commandList", r);
                e.ensureTerminated(L);
            }
            var O = {
                displayName: a,
                events: i,
                start: C,
                every: n,
                execCount: 0,
                errorHandler: A,
                errorSymbol: R,
                execute: function(e) {
                    let r = t.getEventQueueFor(e.me, O);
                    if (r.executing && n === false) {
                        if (I || q && r.queue.length > 0) return;
                        if (S) r.queue.length = 0;
                        r.queue.push(e);
                        return;
                    }
                    O.execCount++;
                    r.executing = true;
                    e.meta.onHalt = function() {
                        r.executing = false;
                        var e = r.queue.shift();
                        if (e) setTimeout(function() {
                            O.execute(e);
                        }, 1);
                    };
                    e.meta.reject = function(r) {
                        console.error(r.message ? r.message : r);
                        var n = t.getHyperTrace(e, r);
                        if (n) n.print();
                        t.triggerEvent(e.me, "exception", {
                            error: r
                        });
                    };
                    C.execute(e);
                },
                install: function(e, r) {
                    for (const r of O.events){
                        var n;
                        if (r.elsewhere) n = [
                            document
                        ];
                        else if (r.from) n = r.from.evaluate(t.makeContext(e, O, e, null));
                        else n = [
                            e
                        ];
                        t.implicitLoop(n, function(n) {
                            var i = r.on;
                            if (n == null) {
                                console.warn("'%s' feature ignored because target does not exists:", a, e);
                                return;
                            }
                            if (r.mutationSpec) {
                                i = "hyperscript:mutation";
                                const e = new MutationObserver(function(e, r) {
                                    if (!O.executing) t.triggerEvent(n, i, {
                                        mutationList: e,
                                        observer: r
                                    });
                                });
                                e.observe(n, r.mutationSpec);
                            }
                            if (r.intersectionSpec) {
                                i = "hyperscript:intersection";
                                const e = new IntersectionObserver(function(r) {
                                    for (const o of r){
                                        var a = {
                                            observer: e
                                        };
                                        a = Object.assign(a, o);
                                        a["intersecting"] = o.isIntersecting;
                                        t.triggerEvent(n, i, a);
                                    }
                                }, r.intersectionSpec);
                                e.observe(n);
                            }
                            var o = n.addEventListener || n.on;
                            o.call(n, i, function a(o) {
                                if (typeof Node !== "undefined" && e instanceof Node && n !== e && !e.isConnected) {
                                    n.removeEventListener(i, a);
                                    return;
                                }
                                var s = t.makeContext(e, O, e, o);
                                if (r.elsewhere && e.contains(o.target)) return;
                                if (r.from) s.result = n;
                                for (const e of r.args){
                                    let t = s.event[e.value];
                                    if (t !== undefined) s.locals[e.value] = t;
                                    else if ("detail" in s.event) s.locals[e.value] = s.event["detail"][e.value];
                                }
                                s.meta.errorHandler = A;
                                s.meta.errorSymbol = R;
                                s.meta.finallyHandler = L;
                                if (r.filter) {
                                    var u = s.meta.context;
                                    s.meta.context = s.event;
                                    try {
                                        var l = r.filter.evaluate(s);
                                        if (l) ;
                                        else return;
                                    } finally{
                                        s.meta.context = u;
                                    }
                                }
                                if (r.inExpr) {
                                    var c = o.target;
                                    while(true)if (c.matches && c.matches(r.inExpr.css)) {
                                        s.result = c;
                                        break;
                                    } else {
                                        c = c.parentElement;
                                        if (c == null) return;
                                    }
                                }
                                r.execCount++;
                                if (r.startCount) {
                                    if (r.endCount) {
                                        if (r.execCount < r.startCount || r.execCount > r.endCount) return;
                                    } else if (r.unbounded) {
                                        if (r.execCount < r.startCount) return;
                                    } else if (r.execCount !== r.startCount) return;
                                }
                                if (r.debounceTime) {
                                    if (r.debounced) clearTimeout(r.debounced);
                                    r.debounced = setTimeout(function() {
                                        O.execute(s);
                                    }, r.debounceTime);
                                    return;
                                }
                                if (r.throttleTime) {
                                    if (r.lastExec && Date.now() < r.lastExec + r.throttleTime) return;
                                    else r.lastExec = Date.now();
                                }
                                O.execute(s);
                            });
                        });
                    }
                }
            };
            e.setParent(C, O);
            return O;
        });
        t.addFeature("def", function(e, t, r) {
            if (!r.matchToken("def")) return;
            var n = e.requireElement("dotOrColonPath", r);
            var i = n.evaluate();
            var a = i.split(".");
            var o = a.pop();
            var s = [];
            if (r.matchOpToken("(")) {
                if (r.matchOpToken(")")) ;
                else {
                    do s.push(r.requireTokenType("IDENTIFIER"));
                    while (r.matchOpToken(","));
                    r.requireOpToken(")");
                }
            }
            var u = e.requireElement("commandList", r);
            var l, c;
            if (r.matchToken("catch")) {
                l = r.requireTokenType("IDENTIFIER").value;
                c = e.parseElement("commandList", r);
            }
            if (r.matchToken("finally")) {
                var f = e.requireElement("commandList", r);
                e.ensureTerminated(f);
            }
            var m = {
                displayName: o + "(" + s.map(function(e) {
                    return e.value;
                }).join(", ") + ")",
                name: o,
                args: s,
                start: u,
                errorHandler: c,
                errorSymbol: l,
                finallyHandler: f,
                install: function(e, r) {
                    var n = function() {
                        var n = t.makeContext(r, m, e, null);
                        n.meta.errorHandler = c;
                        n.meta.errorSymbol = l;
                        n.meta.finallyHandler = f;
                        for(var i = 0; i < s.length; i++){
                            var a = s[i];
                            var o = arguments[i];
                            if (a) n.locals[a.value] = o;
                        }
                        n.meta.caller = arguments[s.length];
                        if (n.meta.caller) n.meta.callingCommand = n.meta.caller.meta.command;
                        var p, h = null;
                        var v = new Promise(function(e, t) {
                            p = e;
                            h = t;
                        });
                        u.execute(n);
                        if (n.meta.returned) return n.meta.returnValue;
                        else {
                            n.meta.resolve = p;
                            n.meta.reject = h;
                            return v;
                        }
                    };
                    n.hyperfunc = true;
                    n.hypername = i;
                    t.assignToNamespace(e, a, o, n);
                }
            };
            e.ensureTerminated(u);
            if (c) e.ensureTerminated(c);
            e.setParent(u, m);
            return m;
        });
        t.addFeature("set", function(e, t, r) {
            let n = e.parseElement("setCommand", r);
            if (n) {
                if (n.target.scope !== "element") e.raiseParseError(r, "variables declared at the feature level must be element scoped.");
                let i = {
                    start: n,
                    install: function(e, r) {
                        n && n.execute(t.makeContext(e, i, e, null));
                    }
                };
                e.ensureTerminated(n);
                return i;
            }
        });
        t.addFeature("init", function(e, t, r) {
            if (!r.matchToken("init")) return;
            var n = r.matchToken("immediately");
            var i = e.requireElement("commandList", r);
            var a = {
                start: i,
                install: function(e, r) {
                    let o = function() {
                        i && i.execute(t.makeContext(e, a, e, null));
                    };
                    if (n) o();
                    else setTimeout(o, 0);
                }
            };
            e.ensureTerminated(i);
            e.setParent(i, a);
            return a;
        });
        t.addFeature("worker", function(e, t, r) {
            if (r.matchToken("worker")) {
                e.raiseParseError(r, "In order to use the 'worker' feature, include the _hyperscript worker plugin. See https://hyperscript.org/features/worker/ for more info.");
                return undefined;
            }
        });
        t.addFeature("behavior", function(t, r, n) {
            if (!n.matchToken("behavior")) return;
            var i = t.requireElement("dotOrColonPath", n).evaluate();
            var a = i.split(".");
            var o = a.pop();
            var s = [];
            if (n.matchOpToken("(") && !n.matchOpToken(")")) {
                do s.push(n.requireTokenType("IDENTIFIER").value);
                while (n.matchOpToken(","));
                n.requireOpToken(")");
            }
            var u = t.requireElement("hyperscript", n);
            for(var l = 0; l < u.features.length; l++){
                var c = u.features[l];
                c.behavior = i;
            }
            return {
                install: function(t, n) {
                    r.assignToNamespace(e.document && e.document.body, a, o, function(e, t, n) {
                        var a = r.getInternalData(e);
                        var o = h(a, i + "Scope");
                        for(var l = 0; l < s.length; l++)o[s[l]] = n[s[l]];
                        u.apply(e, t);
                    });
                }
            };
        });
        t.addFeature("install", function(t, r, n) {
            if (!n.matchToken("install")) return;
            var i = t.requireElement("dotOrColonPath", n).evaluate();
            var a = i.split(".");
            var o = t.parseElement("namedArgumentList", n);
            var s;
            return s = {
                install: function(t, n) {
                    r.unifiedEval({
                        args: [
                            o
                        ],
                        op: function(r, o) {
                            var s = e;
                            for(var u = 0; u < a.length; u++){
                                s = s[a[u]];
                                if (typeof s !== "object" && typeof s !== "function") throw new Error("No such behavior defined as " + i);
                            }
                            if (!(s instanceof Function)) throw new Error(i + " is not a behavior");
                            s(t, n, o);
                        }
                    }, r.makeContext(t, s, t, null));
                }
            };
        });
        t.addGrammarElement("jsBody", function(e, t, r) {
            var n = r.currentToken().start;
            var i = r.currentToken();
            var a = [];
            var o = "";
            var s = false;
            while(r.hasMore()){
                i = r.consumeToken();
                var u = r.token(0, true);
                if (u.type === "IDENTIFIER" && u.value === "end") break;
                if (s) {
                    if (i.type === "IDENTIFIER" || i.type === "NUMBER") o += i.value;
                    else {
                        if (o !== "") a.push(o);
                        o = "";
                        s = false;
                    }
                } else if (i.type === "IDENTIFIER" && i.value === "function") s = true;
            }
            var l = i.end + 1;
            return {
                type: "jsBody",
                exposedFunctionNames: a,
                jsSource: r.source.substring(n, l)
            };
        });
        t.addFeature("js", function(t, r, n) {
            if (!n.matchToken("js")) return;
            var i = t.requireElement("jsBody", n);
            var a = i.jsSource + "\nreturn { " + i.exposedFunctionNames.map(function(e) {
                return e + ":" + e;
            }).join(",") + " } ";
            var o = new Function(a);
            return {
                jsSource: a,
                function: o,
                exposedFunctionNames: i.exposedFunctionNames,
                install: function() {
                    Object.assign(e, o());
                }
            };
        });
        t.addCommand("js", function(t, r, n) {
            if (!n.matchToken("js")) return;
            var i = [];
            if (n.matchOpToken("(")) {
                if (n.matchOpToken(")")) ;
                else {
                    do {
                        var a = n.requireTokenType("IDENTIFIER");
                        i.push(a.value);
                    }while (n.matchOpToken(","));
                    n.requireOpToken(")");
                }
            }
            var o = t.requireElement("jsBody", n);
            n.matchToken("end");
            var s = E(Function, i.concat([
                o.jsSource
            ]));
            var u = {
                jsSource: o.jsSource,
                function: s,
                inputs: i,
                op: function(t) {
                    var n = [];
                    i.forEach(function(e) {
                        n.push(r.resolveSymbol(e, t, "default"));
                    });
                    var a = s.apply(e, n);
                    if (a && typeof a.then === "function") return new Promise(function(e) {
                        a.then(function(n) {
                            t.result = n;
                            e(r.findNext(this, t));
                        });
                    });
                    else {
                        t.result = a;
                        return r.findNext(this, t);
                    }
                }
            };
            return u;
        });
        t.addCommand("async", function(e, t, r) {
            if (!r.matchToken("async")) return;
            if (r.matchToken("do")) {
                var n = e.requireElement("commandList", r);
                var i = n;
                while(i.next)i = i.next;
                i.next = t.HALT;
                r.requireToken("end");
            } else var n = e.requireElement("command", r);
            var a = {
                body: n,
                op: function(e) {
                    setTimeout(function() {
                        n.execute(e);
                    });
                    return t.findNext(this, e);
                }
            };
            e.setParent(n, a);
            return a;
        });
        t.addCommand("tell", function(e, t, r) {
            var n = r.currentToken();
            if (!r.matchToken("tell")) return;
            var i = e.requireElement("expression", r);
            var a = e.requireElement("commandList", r);
            if (r.hasMore() && !e.featureStart(r.currentToken())) r.requireToken("end");
            var o = "tell_" + n.start;
            var s = {
                value: i,
                body: a,
                args: [
                    i
                ],
                resolveNext: function(e) {
                    var r = e.meta.iterators[o];
                    if (r.index < r.value.length) {
                        e.you = r.value[r.index++];
                        return a;
                    } else {
                        e.you = r.originalYou;
                        if (this.next) return this.next;
                        else return t.findNext(this.parent, e);
                    }
                },
                op: function(e, t) {
                    if (t == null) t = [];
                    else if (!(Array.isArray(t) || t instanceof NodeList)) t = [
                        t
                    ];
                    e.meta.iterators[o] = {
                        originalYou: e.you,
                        index: 0,
                        value: t
                    };
                    return this.resolveNext(e);
                }
            };
            e.setParent(a, s);
            return s;
        });
        t.addCommand("wait", function(e, t, r) {
            if (!r.matchToken("wait")) return;
            var n;
            if (r.matchToken("for")) {
                r.matchToken("a");
                var i = [];
                do {
                    var a = r.token(0);
                    if (a.type === "NUMBER" || a.type === "L_PAREN") i.push({
                        time: e.requireElement("expression", r).evaluate()
                    });
                    else i.push({
                        name: e.requireElement("dotOrColonPath", r, "Expected event name").evaluate(),
                        args: v(r)
                    });
                }while (r.matchToken("or"));
                if (r.matchToken("from")) var o = e.requireElement("expression", r);
                n = {
                    event: i,
                    on: o,
                    args: [
                        o
                    ],
                    op: function(e, r) {
                        var n = r ? r : e.me;
                        if (!(n instanceof EventTarget)) throw new Error("Not a valid event target: " + this.on.sourceFor());
                        return new Promise((r)=>{
                            var a = false;
                            for (const s of i){
                                var o = (n)=>{
                                    e.result = n;
                                    if (s.args) for (const t of s.args)e.locals[t.value] = n[t.value] || (n.detail ? n.detail[t.value] : null);
                                    if (!a) {
                                        a = true;
                                        r(t.findNext(this, e));
                                    }
                                };
                                if (s.name) n.addEventListener(s.name, o, {
                                    once: true
                                });
                                else if (s.time != null) setTimeout(o, s.time, s.time);
                            }
                        });
                    }
                };
                return n;
            } else {
                var s;
                if (r.matchToken("a")) {
                    r.requireToken("tick");
                    s = 0;
                } else s = e.requireElement("expression", r);
                n = {
                    type: "waitCmd",
                    time: s,
                    args: [
                        s
                    ],
                    op: function(e, r) {
                        return new Promise((n)=>{
                            setTimeout(()=>{
                                n(t.findNext(this, e));
                            }, r);
                        });
                    },
                    execute: function(e) {
                        return t.unifiedExec(this, e);
                    }
                };
                return n;
            }
        });
        t.addGrammarElement("dotOrColonPath", function(e, t, r) {
            var n = r.matchTokenType("IDENTIFIER");
            if (n) {
                var i = [
                    n.value
                ];
                var a = r.matchOpToken(".") || r.matchOpToken(":");
                if (a) do i.push(r.requireTokenType("IDENTIFIER", "NUMBER").value);
                while (r.matchOpToken(a.value));
                return {
                    type: "dotOrColonPath",
                    path: i,
                    evaluate: function() {
                        return i.join(a ? a.value : "");
                    }
                };
            }
        });
        t.addGrammarElement("eventName", function(e, t, r) {
            var n;
            if (n = r.matchTokenType("STRING")) return {
                evaluate: function() {
                    return n.value;
                }
            };
            return e.parseElement("dotOrColonPath", r);
        });
        function d(e, t, r, n) {
            var i = t.requireElement("eventName", n);
            var a = t.parseElement("namedArgumentList", n);
            if (e === "send" && n.matchToken("to") || e === "trigger" && n.matchToken("on")) var o = t.requireElement("expression", n);
            else var o = t.requireElement("implicitMeTarget", n);
            var s = {
                eventName: i,
                details: a,
                to: o,
                args: [
                    o,
                    i,
                    a
                ],
                op: function(e, t, n, i) {
                    r.nullCheck(t, o);
                    r.implicitLoop(t, function(t) {
                        r.triggerEvent(t, n, i, e.me);
                    });
                    return r.findNext(s, e);
                }
            };
            return s;
        }
        t.addCommand("trigger", function(e, t, r) {
            if (r.matchToken("trigger")) return d("trigger", e, t, r);
        });
        t.addCommand("send", function(e, t, r) {
            if (r.matchToken("send")) return d("send", e, t, r);
        });
        var T = function(e, t, r, n) {
            if (n) {
                if (e.commandBoundary(r.currentToken())) e.raiseParseError(r, "'return' commands must return a value.  If you do not wish to return a value, use 'exit' instead.");
                else var i = e.requireElement("expression", r);
            }
            var a = {
                value: i,
                args: [
                    i
                ],
                op: function(e, r) {
                    var n = e.meta.resolve;
                    e.meta.returned = true;
                    e.meta.returnValue = r;
                    if (n) {
                        if (r) n(r);
                        else n();
                    }
                    return t.HALT;
                }
            };
            return a;
        };
        t.addCommand("return", function(e, t, r) {
            if (r.matchToken("return")) return T(e, t, r, true);
        });
        t.addCommand("exit", function(e, t, r) {
            if (r.matchToken("exit")) return T(e, t, r, false);
        });
        t.addCommand("halt", function(e, t, r) {
            if (r.matchToken("halt")) {
                if (r.matchToken("the")) {
                    r.requireToken("event");
                    if (r.matchOpToken("'")) r.requireToken("s");
                    var n = true;
                }
                if (r.matchToken("bubbling")) var i = true;
                else if (r.matchToken("default")) var a = true;
                var o = T(e, t, r, false);
                var s = {
                    keepExecuting: true,
                    bubbling: i,
                    haltDefault: a,
                    exit: o,
                    op: function(e) {
                        if (e.event) {
                            if (i) e.event.stopPropagation();
                            else if (a) e.event.preventDefault();
                            else {
                                e.event.stopPropagation();
                                e.event.preventDefault();
                            }
                            if (n) return t.findNext(this, e);
                            else return o;
                        }
                    }
                };
                return s;
            }
        });
        t.addCommand("log", function(e, t, r) {
            if (!r.matchToken("log")) return;
            var n = [
                e.parseElement("expression", r)
            ];
            while(r.matchOpToken(","))n.push(e.requireElement("expression", r));
            if (r.matchToken("with")) var i = e.requireElement("expression", r);
            var a = {
                exprs: n,
                withExpr: i,
                args: [
                    i,
                    n
                ],
                op: function(e, r, n) {
                    if (r) r.apply(null, n);
                    else console.log.apply(null, n);
                    return t.findNext(this, e);
                }
            };
            return a;
        });
        t.addCommand("beep!", function(e, t, r) {
            if (!r.matchToken("beep!")) return;
            var n = [
                e.parseElement("expression", r)
            ];
            while(r.matchOpToken(","))n.push(e.requireElement("expression", r));
            var i = {
                exprs: n,
                args: [
                    n
                ],
                op: function(e, r) {
                    for(let i = 0; i < n.length; i++){
                        const a = n[i];
                        const o = r[i];
                        t.beepValueToConsole(e.me, a, o);
                    }
                    return t.findNext(this, e);
                }
            };
            return i;
        });
        t.addCommand("throw", function(e, t, r) {
            if (!r.matchToken("throw")) return;
            var n = e.requireElement("expression", r);
            var i = {
                expr: n,
                args: [
                    n
                ],
                op: function(e, r) {
                    t.registerHyperTrace(e, r);
                    throw r;
                }
            };
            return i;
        });
        var y = function(e, t, r) {
            var n = e.requireElement("expression", r);
            var i = {
                expr: n,
                args: [
                    n
                ],
                op: function(e, r) {
                    e.result = r;
                    return t.findNext(i, e);
                }
            };
            return i;
        };
        t.addCommand("call", function(e, t, r) {
            if (!r.matchToken("call")) return;
            var n = y(e, t, r);
            if (n.expr && n.expr.type !== "functionCall") e.raiseParseError(r, "Must be a function invocation");
            return n;
        });
        t.addCommand("get", function(e, t, r) {
            if (r.matchToken("get")) return y(e, t, r);
        });
        t.addCommand("make", function(e, t, r) {
            if (!r.matchToken("make")) return;
            r.matchToken("a") || r.matchToken("an");
            var n = e.requireElement("expression", r);
            var i = [];
            if (n.type !== "queryRef" && r.matchToken("from")) do i.push(e.requireElement("expression", r));
            while (r.matchOpToken(","));
            if (r.matchToken("called")) var a = e.requireElement("symbol", r);
            var o;
            if (n.type === "queryRef") {
                o = {
                    op: function(e) {
                        var r, i = "div", o, s = [];
                        var u = /(?:(^|#|\.)([^#\. ]+))/g;
                        while(r = u.exec(n.css)){
                            if (r[1] === "") i = r[2].trim();
                            else if (r[1] === "#") o = r[2].trim();
                            else s.push(r[2].trim());
                        }
                        var l = document.createElement(i);
                        if (o !== undefined) l.id = o;
                        for(var c = 0; c < s.length; c++){
                            var f = s[c];
                            l.classList.add(f);
                        }
                        e.result = l;
                        if (a) t.setSymbol(a.name, e, a.scope, l);
                        return t.findNext(this, e);
                    }
                };
                return o;
            } else {
                o = {
                    args: [
                        n,
                        i
                    ],
                    op: function(e, r, n) {
                        e.result = E(r, n);
                        if (a) t.setSymbol(a.name, e, a.scope, e.result);
                        return t.findNext(this, e);
                    }
                };
                return o;
            }
        });
        t.addGrammarElement("pseudoCommand", function(e, t, r) {
            let n = r.token(1);
            if (!(n && n.op && (n.value === "." || n.value === "("))) return null;
            var i = e.requireElement("primaryExpression", r);
            var a = i.root;
            var o = i;
            while(a.root != null){
                o = o.root;
                a = a.root;
            }
            if (i.type !== "functionCall") e.raiseParseError(r, "Pseudo-commands must be function calls");
            if (o.type === "functionCall" && o.root.root == null) {
                if (r.matchAnyToken("the", "to", "on", "with", "into", "from", "at")) var s = e.requireElement("expression", r);
                else if (r.matchToken("me")) var s = e.requireElement("implicitMeTarget", r);
            }
            var u;
            if (s) u = {
                type: "pseudoCommand",
                root: s,
                argExressions: o.argExressions,
                args: [
                    s,
                    o.argExressions
                ],
                op: function(e, r, n) {
                    t.nullCheck(r, s);
                    var i = r[o.root.name];
                    t.nullCheck(i, o);
                    if (i.hyperfunc) n.push(e);
                    e.result = i.apply(r, n);
                    return t.findNext(u, e);
                },
                execute: function(e) {
                    return t.unifiedExec(this, e);
                }
            };
            else u = {
                type: "pseudoCommand",
                expr: i,
                args: [
                    i
                ],
                op: function(e, r) {
                    e.result = r;
                    return t.findNext(u, e);
                },
                execute: function(e) {
                    return t.unifiedExec(this, e);
                }
            };
            return u;
        });
        var k = function(e, t, r, n, i) {
            var a = n.type === "symbol";
            var o = n.type === "attributeRef";
            var s = n.type === "styleRef";
            var u = n.type === "arrayIndex";
            if (!(o || s || a) && n.root == null) e.raiseParseError(r, "Can only put directly into symbols, not references");
            var l = null;
            var c = null;
            if (a) ;
            else if (o || s) {
                l = e.requireElement("implicitMeTarget", r);
                var f = n;
            } else if (u) {
                c = n.firstIndex;
                l = n.root;
            } else {
                c = n.prop ? n.prop.value : null;
                var f = n.attribute;
                l = n.root;
            }
            var m = {
                target: n,
                symbolWrite: a,
                value: i,
                args: [
                    l,
                    c,
                    i
                ],
                op: function(e, r, i, o) {
                    if (a) t.setSymbol(n.name, e, n.scope, o);
                    else {
                        t.nullCheck(r, l);
                        if (u) r[i] = o;
                        else t.implicitLoop(r, function(e) {
                            if (f) {
                                if (f.type === "attributeRef") {
                                    if (o == null) e.removeAttribute(f.name);
                                    else e.setAttribute(f.name, o);
                                } else e.style[f.name] = o;
                            } else e[i] = o;
                        });
                    }
                    return t.findNext(this, e);
                }
            };
            return m;
        };
        t.addCommand("default", function(e, t, r) {
            if (!r.matchToken("default")) return;
            var n = e.requireElement("assignableExpression", r);
            r.requireToken("to");
            var i = e.requireElement("expression", r);
            var a = k(e, t, r, n, i);
            var o = {
                target: n,
                value: i,
                setter: a,
                args: [
                    n
                ],
                op: function(e, r) {
                    if (r) return t.findNext(this, e);
                    else return a;
                }
            };
            a.parent = o;
            return o;
        });
        t.addCommand("set", function(e, t, r) {
            if (!r.matchToken("set")) return;
            if (r.currentToken().type === "L_BRACE") {
                var n = e.requireElement("objectLiteral", r);
                r.requireToken("on");
                var i = e.requireElement("expression", r);
                var a = {
                    objectLiteral: n,
                    target: i,
                    args: [
                        n,
                        i
                    ],
                    op: function(e, r, n) {
                        Object.assign(n, r);
                        return t.findNext(this, e);
                    }
                };
                return a;
            }
            try {
                r.pushFollow("to");
                var i = e.requireElement("assignableExpression", r);
            } finally{
                r.popFollow();
            }
            r.requireToken("to");
            var o = e.requireElement("expression", r);
            return k(e, t, r, i, o);
        });
        t.addCommand("if", function(e, t, r) {
            if (!r.matchToken("if")) return;
            var n = e.requireElement("expression", r);
            r.matchToken("then");
            var i = e.parseElement("commandList", r);
            var a = false;
            let o = r.matchToken("else") || r.matchToken("otherwise");
            if (o) {
                let t = r.peekToken("if");
                a = t != null && t.line === o.line;
                if (a) var s = e.parseElement("command", r);
                else var s = e.parseElement("commandList", r);
            }
            if (r.hasMore() && !a) r.requireToken("end");
            var u = {
                expr: n,
                trueBranch: i,
                falseBranch: s,
                args: [
                    n
                ],
                op: function(e, r) {
                    if (r) return i;
                    else if (s) return s;
                    else return t.findNext(this, e);
                }
            };
            e.setParent(i, u);
            e.setParent(s, u);
            return u;
        });
        var x = function(e, t, r, n) {
            var i = t.currentToken();
            var a;
            if (t.matchToken("for") || n) {
                var o = t.requireTokenType("IDENTIFIER");
                a = o.value;
                t.requireToken("in");
                var s = e.requireElement("expression", t);
            } else if (t.matchToken("in")) {
                a = "it";
                var s = e.requireElement("expression", t);
            } else if (t.matchToken("while")) var u = e.requireElement("expression", t);
            else if (t.matchToken("until")) {
                var l = true;
                if (t.matchToken("event")) {
                    var c = e.requireElement("dotOrColonPath", t, "Expected event name");
                    if (t.matchToken("from")) var f = e.requireElement("expression", t);
                } else var u = e.requireElement("expression", t);
            } else if (!e.commandBoundary(t.currentToken()) && t.currentToken().value !== "forever") {
                var m = e.requireElement("expression", t);
                t.requireToken("times");
            } else {
                t.matchToken("forever");
                var p = true;
            }
            if (t.matchToken("index")) {
                var o = t.requireTokenType("IDENTIFIER");
                var h = o.value;
            } else if (t.matchToken("indexed")) {
                t.requireToken("by");
                var o = t.requireTokenType("IDENTIFIER");
                var h = o.value;
            }
            var v = e.parseElement("commandList", t);
            if (v && c) {
                var d = v;
                while(d.next)d = d.next;
                var E = {
                    type: "waitATick",
                    op: function() {
                        return new Promise(function(e) {
                            setTimeout(function() {
                                e(r.findNext(E));
                            }, 0);
                        });
                    }
                };
                d.next = E;
            }
            if (t.hasMore()) t.requireToken("end");
            if (a == null) {
                a = "_implicit_repeat_" + i.start;
                var T = a;
            } else var T = a + "_" + i.start;
            var y = {
                identifier: a,
                indexIdentifier: h,
                slot: T,
                expression: s,
                forever: p,
                times: m,
                until: l,
                event: c,
                on: f,
                whileExpr: u,
                resolveNext: function() {
                    return this;
                },
                loop: v,
                args: [
                    u,
                    m
                ],
                op: function(e, t, n) {
                    var i = e.meta.iterators[T];
                    var o = false;
                    var s = null;
                    if (this.forever) o = true;
                    else if (this.until) {
                        if (c) o = e.meta.iterators[T].eventFired === false;
                        else o = t !== true;
                    } else if (u) o = t;
                    else if (n) o = i.index < n;
                    else {
                        var l = i.iterator.next();
                        o = !l.done;
                        s = l.value;
                    }
                    if (o) {
                        if (i.value) e.result = e.locals[a] = s;
                        else e.result = i.index;
                        if (h) e.locals[h] = i.index;
                        i.index++;
                        return v;
                    } else {
                        e.meta.iterators[T] = null;
                        return r.findNext(this.parent, e);
                    }
                }
            };
            e.setParent(v, y);
            var k = {
                name: "repeatInit",
                args: [
                    s,
                    c,
                    f
                ],
                op: function(e, t, r, n) {
                    var i = {
                        index: 0,
                        value: t,
                        eventFired: false
                    };
                    e.meta.iterators[T] = i;
                    if (t && t[Symbol.iterator]) i.iterator = t[Symbol.iterator]();
                    if (c) {
                        var a = n || e.me;
                        a.addEventListener(r, function(t) {
                            e.meta.iterators[T].eventFired = true;
                        }, {
                            once: true
                        });
                    }
                    return y;
                },
                execute: function(e) {
                    return r.unifiedExec(this, e);
                }
            };
            e.setParent(y, k);
            return k;
        };
        t.addCommand("repeat", function(e, t, r) {
            if (r.matchToken("repeat")) return x(e, r, t, false);
        });
        t.addCommand("for", function(e, t, r) {
            if (r.matchToken("for")) return x(e, r, t, true);
        });
        t.addCommand("continue", function(e, t, r) {
            if (!r.matchToken("continue")) return;
            var n = {
                op: function(t) {
                    for(var n = this.parent;; n = n.parent){
                        if (n == undefined) e.raiseParseError(r, "Command `continue` cannot be used outside of a `repeat` loop.");
                        if (n.loop != undefined) return n.resolveNext(t);
                    }
                }
            };
            return n;
        });
        t.addCommand("break", function(e, t, r) {
            if (!r.matchToken("break")) return;
            var n = {
                op: function(n) {
                    for(var i = this.parent;; i = i.parent){
                        if (i == undefined) e.raiseParseError(r, "Command `continue` cannot be used outside of a `repeat` loop.");
                        if (i.loop != undefined) return t.findNext(i.parent, n);
                    }
                }
            };
            return n;
        });
        t.addGrammarElement("stringLike", function(e, t, r) {
            return e.parseAnyOf([
                "string",
                "nakedString"
            ], r);
        });
        t.addCommand("append", function(e, t, r) {
            if (!r.matchToken("append")) return;
            var n = null;
            var i = e.requireElement("expression", r);
            var a = {
                type: "symbol",
                evaluate: function(e) {
                    return t.resolveSymbol("result", e);
                }
            };
            if (r.matchToken("to")) n = e.requireElement("expression", r);
            else n = a;
            var o = null;
            if (n.type === "symbol" || n.type === "attributeRef" || n.root != null) o = k(e, t, r, n, a);
            var s = {
                value: i,
                target: n,
                args: [
                    n,
                    i
                ],
                op: function(e, r, n) {
                    if (Array.isArray(r)) {
                        r.push(n);
                        return t.findNext(this, e);
                    } else if (r instanceof Element) {
                        if (n instanceof Element) r.insertAdjacentElement("beforeend", n);
                        else r.insertAdjacentHTML("beforeend", n);
                        t.processNode(r);
                        return t.findNext(this, e);
                    } else if (o) {
                        e.result = (r || "") + n;
                        return o;
                    } else throw Error("Unable to append a value!");
                },
                execute: function(e) {
                    return t.unifiedExec(this, e);
                }
            };
            if (o != null) o.parent = s;
            return s;
        });
        function g(e, t, r) {
            r.matchToken("at") || r.matchToken("from");
            const n = {
                includeStart: true,
                includeEnd: false
            };
            n.from = r.matchToken("start") ? 0 : e.requireElement("expression", r);
            if (r.matchToken("to") || r.matchOpToken("..")) {
                if (r.matchToken("end")) n.toEnd = true;
                else n.to = e.requireElement("expression", r);
            }
            if (r.matchToken("inclusive")) n.includeEnd = true;
            else if (r.matchToken("exclusive")) n.includeStart = false;
            return n;
        }
        class b {
            constructor(e, t){
                this.re = e;
                this.str = t;
            }
            next() {
                const e = this.re.exec(this.str);
                if (e === null) return {
                    done: true
                };
                else return {
                    value: e
                };
            }
        }
        class w {
            constructor(e, t, r){
                this.re = e;
                this.flags = t;
                this.str = r;
            }
            [Symbol.iterator]() {
                return new b(new RegExp(this.re, this.flags), this.str);
            }
        }
        t.addCommand("pick", (e, t, r)=>{
            if (!r.matchToken("pick")) return;
            r.matchToken("the");
            if (r.matchToken("item") || r.matchToken("items") || r.matchToken("character") || r.matchToken("characters")) {
                const n = g(e, t, r);
                r.requireToken("from");
                const i = e.requireElement("expression", r);
                return {
                    args: [
                        i,
                        n.from,
                        n.to
                    ],
                    op (e, r, i, a) {
                        if (n.toEnd) a = r.length;
                        if (!n.includeStart) i++;
                        if (n.includeEnd) a++;
                        if (a == null || a == undefined) a = i + 1;
                        e.result = r.slice(i, a);
                        return t.findNext(this, e);
                    }
                };
            }
            if (r.matchToken("match")) {
                r.matchToken("of");
                const n = e.parseElement("expression", r);
                let i = "";
                if (r.matchOpToken("|")) i = r.requireTokenType("IDENTIFIER").value;
                r.requireToken("from");
                const a = e.parseElement("expression", r);
                return {
                    args: [
                        a,
                        n
                    ],
                    op (e, r, n) {
                        e.result = new RegExp(n, i).exec(r);
                        return t.findNext(this, e);
                    }
                };
            }
            if (r.matchToken("matches")) {
                r.matchToken("of");
                const n = e.parseElement("expression", r);
                let i = "gu";
                if (r.matchOpToken("|")) i = "g" + r.requireTokenType("IDENTIFIER").value.replace("g", "");
                r.requireToken("from");
                const a = e.parseElement("expression", r);
                return {
                    args: [
                        a,
                        n
                    ],
                    op (e, r, n) {
                        e.result = new w(n, i, r);
                        return t.findNext(this, e);
                    }
                };
            }
        });
        t.addCommand("increment", function(e, t, r) {
            if (!r.matchToken("increment")) return;
            var n;
            var i = e.parseElement("assignableExpression", r);
            if (r.matchToken("by")) n = e.requireElement("expression", r);
            var a = {
                type: "implicitIncrementOp",
                target: i,
                args: [
                    i,
                    n
                ],
                op: function(e, t, r) {
                    t = t ? parseFloat(t) : 0;
                    r = n ? parseFloat(r) : 1;
                    var i = t + r;
                    e.result = i;
                    return i;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return k(e, t, r, i, a);
        });
        t.addCommand("decrement", function(e, t, r) {
            if (!r.matchToken("decrement")) return;
            var n;
            var i = e.parseElement("assignableExpression", r);
            if (r.matchToken("by")) n = e.requireElement("expression", r);
            var a = {
                type: "implicitDecrementOp",
                target: i,
                args: [
                    i,
                    n
                ],
                op: function(e, t, r) {
                    t = t ? parseFloat(t) : 0;
                    r = n ? parseFloat(r) : 1;
                    var i = t - r;
                    e.result = i;
                    return i;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
            return k(e, t, r, i, a);
        });
        function S(e, t) {
            var r = "text";
            var n;
            e.matchToken("a") || e.matchToken("an");
            if (e.matchToken("json") || e.matchToken("Object")) r = "json";
            else if (e.matchToken("response")) r = "response";
            else if (e.matchToken("html")) r = "html";
            else if (e.matchToken("text")) ;
            else n = t.requireElement("dotOrColonPath", e).evaluate();
            return {
                type: r,
                conversion: n
            };
        }
        t.addCommand("fetch", function(e, t, r) {
            if (!r.matchToken("fetch")) return;
            var n = e.requireElement("stringLike", r);
            if (r.matchToken("as")) var i = S(r, e);
            if (r.matchToken("with") && r.currentToken().value !== "{") var a = e.parseElement("nakedNamedArgumentList", r);
            else var a = e.parseElement("objectLiteral", r);
            if (i == null && r.matchToken("as")) i = S(r, e);
            var o = i ? i.type : "text";
            var s = i ? i.conversion : null;
            var u = {
                url: n,
                argExpressions: a,
                args: [
                    n,
                    a
                ],
                op: function(e, r, n) {
                    var i = n || {};
                    i["sender"] = e.me;
                    i["headers"] = i["headers"] || {};
                    var a = new AbortController;
                    let l = e.me.addEventListener("fetch:abort", function() {
                        a.abort();
                    }, {
                        once: true
                    });
                    i["signal"] = a.signal;
                    t.triggerEvent(e.me, "hyperscript:beforeFetch", i);
                    t.triggerEvent(e.me, "fetch:beforeRequest", i);
                    n = i;
                    var c = false;
                    if (n.timeout) setTimeout(function() {
                        if (!c) a.abort();
                    }, n.timeout);
                    return fetch(r, n).then(function(r) {
                        let n = {
                            response: r
                        };
                        t.triggerEvent(e.me, "fetch:afterResponse", n);
                        r = n.response;
                        if (o === "response") {
                            e.result = r;
                            t.triggerEvent(e.me, "fetch:afterRequest", {
                                result: r
                            });
                            c = true;
                            return t.findNext(u, e);
                        }
                        if (o === "json") return r.json().then(function(r) {
                            e.result = r;
                            t.triggerEvent(e.me, "fetch:afterRequest", {
                                result: r
                            });
                            c = true;
                            return t.findNext(u, e);
                        });
                        return r.text().then(function(r) {
                            if (s) r = t.convertValue(r, s);
                            if (o === "html") r = t.convertValue(r, "Fragment");
                            e.result = r;
                            t.triggerEvent(e.me, "fetch:afterRequest", {
                                result: r
                            });
                            c = true;
                            return t.findNext(u, e);
                        });
                    }).catch(function(r) {
                        t.triggerEvent(e.me, "fetch:error", {
                            reason: r
                        });
                        throw r;
                    }).finally(function() {
                        e.me.removeEventListener("fetch:abort", l);
                    });
                }
            };
            return u;
        });
    }
    function y(e) {
        e.addCommand("settle", function(e, t, r) {
            if (r.matchToken("settle")) {
                if (!e.commandBoundary(r.currentToken())) var n = e.requireElement("expression", r);
                else var n = e.requireElement("implicitMeTarget", r);
                var i = {
                    type: "settleCmd",
                    args: [
                        n
                    ],
                    op: function(e, r) {
                        t.nullCheck(r, n);
                        var a = null;
                        var o = false;
                        var s = false;
                        var u = new Promise(function(e) {
                            a = e;
                        });
                        r.addEventListener("transitionstart", function() {
                            s = true;
                        }, {
                            once: true
                        });
                        setTimeout(function() {
                            if (!s && !o) a(t.findNext(i, e));
                        }, 500);
                        r.addEventListener("transitionend", function() {
                            if (!o) a(t.findNext(i, e));
                        }, {
                            once: true
                        });
                        return u;
                    },
                    execute: function(e) {
                        return t.unifiedExec(this, e);
                    }
                };
                return i;
            }
        });
        e.addCommand("add", function(e, t, r) {
            if (r.matchToken("add")) {
                var n = e.parseElement("classRef", r);
                var i = null;
                var a = null;
                if (n == null) {
                    i = e.parseElement("attributeRef", r);
                    if (i == null) {
                        a = e.parseElement("styleLiteral", r);
                        if (a == null) e.raiseParseError(r, "Expected either a class reference or attribute expression");
                    }
                } else {
                    var o = [
                        n
                    ];
                    while(n = e.parseElement("classRef", r))o.push(n);
                }
                if (r.matchToken("to")) var s = e.requireElement("expression", r);
                else var s = e.requireElement("implicitMeTarget", r);
                if (r.matchToken("when")) {
                    if (a) e.raiseParseError(r, "Only class and properties are supported with a when clause");
                    var u = e.requireElement("expression", r);
                }
                if (o) return {
                    classRefs: o,
                    to: s,
                    args: [
                        s,
                        o
                    ],
                    op: function(e, r, n) {
                        t.nullCheck(r, s);
                        t.forEach(n, function(n) {
                            t.implicitLoop(r, function(r) {
                                if (u) {
                                    e.result = r;
                                    let i = t.evaluateNoPromise(u, e);
                                    if (i) {
                                        if (r instanceof Element) r.classList.add(n.className);
                                    } else if (r instanceof Element) r.classList.remove(n.className);
                                    e.result = null;
                                } else if (r instanceof Element) r.classList.add(n.className);
                            });
                        });
                        return t.findNext(this, e);
                    }
                };
                else if (i) return {
                    type: "addCmd",
                    attributeRef: i,
                    to: s,
                    args: [
                        s
                    ],
                    op: function(e, r, n) {
                        t.nullCheck(r, s);
                        t.implicitLoop(r, function(r) {
                            if (u) {
                                e.result = r;
                                let n = t.evaluateNoPromise(u, e);
                                if (n) r.setAttribute(i.name, i.value);
                                else r.removeAttribute(i.name);
                                e.result = null;
                            } else r.setAttribute(i.name, i.value);
                        });
                        return t.findNext(this, e);
                    },
                    execute: function(e) {
                        return t.unifiedExec(this, e);
                    }
                };
                else return {
                    type: "addCmd",
                    cssDeclaration: a,
                    to: s,
                    args: [
                        s,
                        a
                    ],
                    op: function(e, r, n) {
                        t.nullCheck(r, s);
                        t.implicitLoop(r, function(e) {
                            e.style.cssText += n;
                        });
                        return t.findNext(this, e);
                    },
                    execute: function(e) {
                        return t.unifiedExec(this, e);
                    }
                };
            }
        });
        e.addGrammarElement("styleLiteral", function(e, t, r) {
            if (!r.matchOpToken("{")) return;
            var n = [
                ""
            ];
            var i = [];
            while(r.hasMore()){
                if (r.matchOpToken("\\")) r.consumeToken();
                else if (r.matchOpToken("}")) break;
                else if (r.matchToken("$")) {
                    var a = r.matchOpToken("{");
                    var o = e.parseElement("expression", r);
                    if (a) r.requireOpToken("}");
                    i.push(o);
                    n.push("");
                } else {
                    var s = r.consumeToken();
                    n[n.length - 1] += r.source.substring(s.start, s.end);
                }
                n[n.length - 1] += r.lastWhitespace();
            }
            return {
                type: "styleLiteral",
                args: [
                    i
                ],
                op: function(e, t) {
                    var r = "";
                    n.forEach(function(e, n) {
                        r += e;
                        if (n in t) r += t[n];
                    });
                    return r;
                },
                evaluate: function(e) {
                    return t.unifiedEval(this, e);
                }
            };
        });
        e.addCommand("remove", function(e, t, r) {
            if (r.matchToken("remove")) {
                var n = e.parseElement("classRef", r);
                var i = null;
                var a = null;
                if (n == null) {
                    i = e.parseElement("attributeRef", r);
                    if (i == null) {
                        a = e.parseElement("expression", r);
                        if (a == null) e.raiseParseError(r, "Expected either a class reference, attribute expression or value expression");
                    }
                } else {
                    var o = [
                        n
                    ];
                    while(n = e.parseElement("classRef", r))o.push(n);
                }
                if (r.matchToken("from")) var s = e.requireElement("expression", r);
                else if (a == null) var s = e.requireElement("implicitMeTarget", r);
                if (a) return {
                    elementExpr: a,
                    from: s,
                    args: [
                        a,
                        s
                    ],
                    op: function(e, r, n) {
                        t.nullCheck(r, a);
                        t.implicitLoop(r, function(e) {
                            if (e.parentElement && (n == null || n.contains(e))) e.parentElement.removeChild(e);
                        });
                        return t.findNext(this, e);
                    }
                };
                else return {
                    classRefs: o,
                    attributeRef: i,
                    elementExpr: a,
                    from: s,
                    args: [
                        o,
                        s
                    ],
                    op: function(e, r, n) {
                        t.nullCheck(n, s);
                        if (r) t.forEach(r, function(e) {
                            t.implicitLoop(n, function(t) {
                                t.classList.remove(e.className);
                            });
                        });
                        else t.implicitLoop(n, function(e) {
                            e.removeAttribute(i.name);
                        });
                        return t.findNext(this, e);
                    }
                };
            }
        });
        e.addCommand("toggle", function(e, t, r) {
            if (r.matchToken("toggle")) {
                r.matchAnyToken("the", "my");
                if (r.currentToken().type === "STYLE_REF") {
                    let t = r.consumeToken();
                    var n = t.value.substr(1);
                    var a = true;
                    var o = i(e, r, n);
                    if (r.matchToken("of")) {
                        r.pushFollow("with");
                        try {
                            var s = e.requireElement("expression", r);
                        } finally{
                            r.popFollow();
                        }
                    } else var s = e.requireElement("implicitMeTarget", r);
                } else if (r.matchToken("between")) {
                    var u = true;
                    var l = e.parseElement("classRef", r);
                    r.requireToken("and");
                    var c = e.requireElement("classRef", r);
                } else {
                    var l = e.parseElement("classRef", r);
                    var f = null;
                    if (l == null) {
                        f = e.parseElement("attributeRef", r);
                        if (f == null) e.raiseParseError(r, "Expected either a class reference or attribute expression");
                    } else {
                        var m = [
                            l
                        ];
                        while(l = e.parseElement("classRef", r))m.push(l);
                    }
                }
                if (a !== true) {
                    if (r.matchToken("on")) var s = e.requireElement("expression", r);
                    else var s = e.requireElement("implicitMeTarget", r);
                }
                if (r.matchToken("for")) var p = e.requireElement("expression", r);
                else if (r.matchToken("until")) {
                    var h = e.requireElement("dotOrColonPath", r, "Expected event name");
                    if (r.matchToken("from")) var v = e.requireElement("expression", r);
                }
                var d = {
                    classRef: l,
                    classRef2: c,
                    classRefs: m,
                    attributeRef: f,
                    on: s,
                    time: p,
                    evt: h,
                    from: v,
                    toggle: function(e, r, n, i) {
                        t.nullCheck(e, s);
                        if (a) t.implicitLoop(e, function(e) {
                            o("toggle", e);
                        });
                        else if (u) t.implicitLoop(e, function(e) {
                            if (e.classList.contains(r.className)) {
                                e.classList.remove(r.className);
                                e.classList.add(n.className);
                            } else {
                                e.classList.add(r.className);
                                e.classList.remove(n.className);
                            }
                        });
                        else if (i) t.forEach(i, function(r) {
                            t.implicitLoop(e, function(e) {
                                e.classList.toggle(r.className);
                            });
                        });
                        else t.implicitLoop(e, function(e) {
                            if (e.hasAttribute(f.name)) e.removeAttribute(f.name);
                            else e.setAttribute(f.name, f.value);
                        });
                    },
                    args: [
                        s,
                        p,
                        h,
                        v,
                        l,
                        c,
                        m
                    ],
                    op: function(e, r, n, i, a, o, s, u) {
                        if (n) return new Promise(function(i) {
                            d.toggle(r, o, s, u);
                            setTimeout(function() {
                                d.toggle(r, o, s, u);
                                i(t.findNext(d, e));
                            }, n);
                        });
                        else if (i) return new Promise(function(n) {
                            var l = a || e.me;
                            l.addEventListener(i, function() {
                                d.toggle(r, o, s, u);
                                n(t.findNext(d, e));
                            }, {
                                once: true
                            });
                            d.toggle(r, o, s, u);
                        });
                        else {
                            this.toggle(r, o, s, u);
                            return t.findNext(d, e);
                        }
                    }
                };
                return d;
            }
        });
        var t = {
            display: function(r, n, i) {
                if (i) n.style.display = i;
                else if (r === "toggle") {
                    if (getComputedStyle(n).display === "none") t.display("show", n, i);
                    else t.display("hide", n, i);
                } else if (r === "hide") {
                    const t = e.runtime.getInternalData(n);
                    if (t.originalDisplay == null) t.originalDisplay = n.style.display;
                    n.style.display = "none";
                } else {
                    const t = e.runtime.getInternalData(n);
                    if (t.originalDisplay && t.originalDisplay !== "none") n.style.display = t.originalDisplay;
                    else n.style.removeProperty("display");
                }
            },
            visibility: function(e, r, n) {
                if (n) r.style.visibility = n;
                else if (e === "toggle") {
                    if (getComputedStyle(r).visibility === "hidden") t.visibility("show", r, n);
                    else t.visibility("hide", r, n);
                } else if (e === "hide") r.style.visibility = "hidden";
                else r.style.visibility = "visible";
            },
            opacity: function(e, r, n) {
                if (n) r.style.opacity = n;
                else if (e === "toggle") {
                    if (getComputedStyle(r).opacity === "0") t.opacity("show", r, n);
                    else t.opacity("hide", r, n);
                } else if (e === "hide") r.style.opacity = "0";
                else r.style.opacity = "1";
            }
        };
        var n = function(e, t, r) {
            var n;
            var i = r.currentToken();
            if (i.value === "when" || i.value === "with" || e.commandBoundary(i)) n = e.parseElement("implicitMeTarget", r);
            else n = e.parseElement("expression", r);
            return n;
        };
        var i = function(e, n, i) {
            var a = r.defaultHideShowStrategy;
            var o = t;
            if (r.hideShowStrategies) o = Object.assign(o, r.hideShowStrategies);
            i = i || a || "display";
            var s = o[i];
            if (s == null) e.raiseParseError(n, "Unknown show/hide strategy : " + i);
            return s;
        };
        e.addCommand("hide", function(e, t, r) {
            if (r.matchToken("hide")) {
                var a = n(e, t, r);
                var o = null;
                if (r.matchToken("with")) {
                    o = r.requireTokenType("IDENTIFIER", "STYLE_REF").value;
                    if (o.indexOf("*") === 0) o = o.substr(1);
                }
                var s = i(e, r, o);
                return {
                    target: a,
                    args: [
                        a
                    ],
                    op: function(e, r) {
                        t.nullCheck(r, a);
                        t.implicitLoop(r, function(e) {
                            s("hide", e);
                        });
                        return t.findNext(this, e);
                    }
                };
            }
        });
        e.addCommand("show", function(e, t, r) {
            if (r.matchToken("show")) {
                var a = n(e, t, r);
                var o = null;
                if (r.matchToken("with")) {
                    o = r.requireTokenType("IDENTIFIER", "STYLE_REF").value;
                    if (o.indexOf("*") === 0) o = o.substr(1);
                }
                var s = null;
                if (r.matchOpToken(":")) {
                    var u = r.consumeUntilWhitespace();
                    r.matchTokenType("WHITESPACE");
                    s = u.map(function(e) {
                        return e.value;
                    }).join("");
                }
                if (r.matchToken("when")) var l = e.requireElement("expression", r);
                var c = i(e, r, o);
                return {
                    target: a,
                    when: l,
                    args: [
                        a
                    ],
                    op: function(e, r) {
                        t.nullCheck(r, a);
                        t.implicitLoop(r, function(r) {
                            if (l) {
                                e.result = r;
                                let n = t.evaluateNoPromise(l, e);
                                if (n) c("show", r, s);
                                else c("hide", r);
                                e.result = null;
                            } else c("show", r, s);
                        });
                        return t.findNext(this, e);
                    }
                };
            }
        });
        e.addCommand("take", function(e, t, r) {
            if (r.matchToken("take")) {
                let u = null;
                let l = [];
                while(u = e.parseElement("classRef", r))l.push(u);
                var n = null;
                var i = null;
                let c = l.length > 0;
                if (!c) {
                    n = e.parseElement("attributeRef", r);
                    if (n == null) e.raiseParseError(r, "Expected either a class reference or attribute expression");
                    if (r.matchToken("with")) i = e.requireElement("expression", r);
                }
                if (r.matchToken("from")) var a = e.requireElement("expression", r);
                if (r.matchToken("for")) var o = e.requireElement("expression", r);
                else var o = e.requireElement("implicitMeTarget", r);
                if (c) {
                    var s = {
                        classRefs: l,
                        from: a,
                        forElt: o,
                        args: [
                            l,
                            a,
                            o
                        ],
                        op: function(e, r, n, i) {
                            t.nullCheck(i, o);
                            t.implicitLoop(r, function(e) {
                                var r = e.className;
                                if (n) t.implicitLoop(n, function(e) {
                                    e.classList.remove(r);
                                });
                                else t.implicitLoop(e, function(e) {
                                    e.classList.remove(r);
                                });
                                t.implicitLoop(i, function(e) {
                                    e.classList.add(r);
                                });
                            });
                            return t.findNext(this, e);
                        }
                    };
                    return s;
                } else {
                    var s = {
                        attributeRef: n,
                        from: a,
                        forElt: o,
                        args: [
                            a,
                            o,
                            i
                        ],
                        op: function(e, r, i, s) {
                            t.nullCheck(r, a);
                            t.nullCheck(i, o);
                            t.implicitLoop(r, function(e) {
                                if (!s) e.removeAttribute(n.name);
                                else e.setAttribute(n.name, s);
                            });
                            t.implicitLoop(i, function(e) {
                                e.setAttribute(n.name, n.value || "");
                            });
                            return t.findNext(this, e);
                        }
                    };
                    return s;
                }
            }
        });
        function a(t, r, n, i) {
            if (n != null) var a = t.resolveSymbol(n, r);
            else var a = r;
            if (a instanceof Element || a instanceof HTMLDocument) {
                while(a.firstChild)a.removeChild(a.firstChild);
                a.append(e.runtime.convertValue(i, "Fragment"));
                t.processNode(a);
            } else {
                if (n != null) t.setSymbol(n, r, null, i);
                else throw "Don't know how to put a value into " + typeof r;
            }
        }
        e.addCommand("put", function(e, t, r) {
            if (r.matchToken("put")) {
                var n = e.requireElement("expression", r);
                var i = r.matchAnyToken("into", "before", "after");
                if (i == null && r.matchToken("at")) {
                    r.matchToken("the");
                    i = r.matchAnyToken("start", "end");
                    r.requireToken("of");
                }
                if (i == null) e.raiseParseError(r, "Expected one of 'into', 'before', 'at start of', 'at end of', 'after'");
                var o = e.requireElement("expression", r);
                var s = i.value;
                var u = false;
                var l = false;
                var c = null;
                var f = null;
                if (o.type === "arrayIndex" && s === "into") {
                    u = true;
                    f = o.prop;
                    c = o.root;
                } else if (o.prop && o.root && s === "into") {
                    f = o.prop.value;
                    c = o.root;
                } else if (o.type === "symbol" && s === "into") {
                    l = true;
                    f = o.name;
                } else if (o.type === "attributeRef" && s === "into") {
                    var m = true;
                    f = o.name;
                    c = e.requireElement("implicitMeTarget", r);
                } else if (o.type === "styleRef" && s === "into") {
                    var p = true;
                    f = o.name;
                    c = e.requireElement("implicitMeTarget", r);
                } else if (o.attribute && s === "into") {
                    var m = o.attribute.type === "attributeRef";
                    var p = o.attribute.type === "styleRef";
                    f = o.attribute.name;
                    c = o.root;
                } else c = o;
                var h = {
                    target: o,
                    operation: s,
                    symbolWrite: l,
                    value: n,
                    args: [
                        c,
                        f,
                        n
                    ],
                    op: function(e, r, n, i) {
                        if (l) a(t, e, n, i);
                        else {
                            t.nullCheck(r, c);
                            if (s === "into") {
                                if (m) t.implicitLoop(r, function(e) {
                                    e.setAttribute(n, i);
                                });
                                else if (p) t.implicitLoop(r, function(e) {
                                    e.style[n] = i;
                                });
                                else if (u) r[n] = i;
                                else t.implicitLoop(r, function(e) {
                                    a(t, e, n, i);
                                });
                            } else {
                                var o = s === "before" ? Element.prototype.before : s === "after" ? Element.prototype.after : s === "start" ? Element.prototype.prepend : s === "end" ? Element.prototype.append : Element.prototype.append;
                                t.implicitLoop(r, function(e) {
                                    o.call(e, i instanceof Node ? i : t.convertValue(i, "Fragment"));
                                    if (e.parentElement) t.processNode(e.parentElement);
                                    else t.processNode(e);
                                });
                            }
                        }
                        return t.findNext(this, e);
                    }
                };
                return h;
            }
        });
        function o(e, t, r) {
            var n;
            if (r.matchToken("the") || r.matchToken("element") || r.matchToken("elements") || r.currentToken().type === "CLASS_REF" || r.currentToken().type === "ID_REF" || r.currentToken().op && r.currentToken().value === "<") {
                e.possessivesDisabled = true;
                try {
                    n = e.parseElement("expression", r);
                } finally{
                    delete e.possessivesDisabled;
                }
                if (r.matchOpToken("'")) r.requireToken("s");
            } else if (r.currentToken().type === "IDENTIFIER" && r.currentToken().value === "its") {
                var i = r.matchToken("its");
                n = {
                    type: "pseudopossessiveIts",
                    token: i,
                    name: i.value,
                    evaluate: function(e) {
                        return t.resolveSymbol("it", e);
                    }
                };
            } else {
                r.matchToken("my") || r.matchToken("me");
                n = e.parseElement("implicitMeTarget", r);
            }
            return n;
        }
        e.addCommand("transition", function(e, t, n) {
            if (n.matchToken("transition")) {
                var i = o(e, t, n);
                var a = [];
                var s = [];
                var u = [];
                var l = n.currentToken();
                while(!e.commandBoundary(l) && l.value !== "over" && l.value !== "using"){
                    if (n.currentToken().type === "STYLE_REF") {
                        let e = n.consumeToken();
                        let t = e.value.substr(1);
                        a.push({
                            type: "styleRefValue",
                            evaluate: function() {
                                return t;
                            }
                        });
                    } else a.push(e.requireElement("stringLike", n));
                    if (n.matchToken("from")) s.push(e.requireElement("expression", n));
                    else s.push(null);
                    n.requireToken("to");
                    if (n.matchToken("initial")) u.push({
                        type: "initial_literal",
                        evaluate: function() {
                            return "initial";
                        }
                    });
                    else u.push(e.requireElement("expression", n));
                    l = n.currentToken();
                }
                if (n.matchToken("over")) var c = e.requireElement("expression", n);
                else if (n.matchToken("using")) var f = e.requireElement("expression", n);
                var m = {
                    to: u,
                    args: [
                        i,
                        a,
                        s,
                        u,
                        f,
                        c
                    ],
                    op: function(e, n, a, o, s, u, l) {
                        t.nullCheck(n, i);
                        var c = [];
                        t.implicitLoop(n, function(e) {
                            var n = new Promise(function(n, i) {
                                var c = e.style.transition;
                                if (l) e.style.transition = "all " + l + "ms ease-in";
                                else if (u) e.style.transition = u;
                                else e.style.transition = r.defaultTransition;
                                var f = t.getInternalData(e);
                                var m = getComputedStyle(e);
                                var p = {};
                                for(var h = 0; h < m.length; h++){
                                    var v = m[h];
                                    var d = m[v];
                                    p[v] = d;
                                }
                                if (!f.initialStyles) f.initialStyles = p;
                                for(var h = 0; h < a.length; h++){
                                    var E = a[h];
                                    var T = o[h];
                                    if (T === "computed" || T == null) e.style[E] = p[E];
                                    else e.style[E] = T;
                                }
                                var y = false;
                                var k = false;
                                e.addEventListener("transitionend", function() {
                                    if (!k) {
                                        e.style.transition = c;
                                        k = true;
                                        n();
                                    }
                                }, {
                                    once: true
                                });
                                e.addEventListener("transitionstart", function() {
                                    y = true;
                                }, {
                                    once: true
                                });
                                setTimeout(function() {
                                    if (!k && !y) {
                                        e.style.transition = c;
                                        k = true;
                                        n();
                                    }
                                }, 100);
                                setTimeout(function() {
                                    var t = [];
                                    for(var r = 0; r < a.length; r++){
                                        var n = a[r];
                                        var i = s[r];
                                        if (i === "initial") {
                                            var o = f.initialStyles[n];
                                            e.style[n] = o;
                                        } else e.style[n] = i;
                                    }
                                }, 0);
                            });
                            c.push(n);
                        });
                        return Promise.all(c).then(function() {
                            return t.findNext(m, e);
                        });
                    }
                };
                return m;
            }
        });
        e.addCommand("measure", function(e, t, r) {
            if (!r.matchToken("measure")) return;
            var n = o(e, t, r);
            var i = [];
            if (!e.commandBoundary(r.currentToken())) do i.push(r.matchTokenType("IDENTIFIER").value);
            while (r.matchOpToken(","));
            return {
                properties: i,
                args: [
                    n
                ],
                op: function(e, r) {
                    t.nullCheck(r, n);
                    if (0 in r) r = r[0];
                    var a = r.getBoundingClientRect();
                    var o = {
                        top: r.scrollTop,
                        left: r.scrollLeft,
                        topMax: r.scrollTopMax,
                        leftMax: r.scrollLeftMax,
                        height: r.scrollHeight,
                        width: r.scrollWidth
                    };
                    e.result = {
                        x: a.x,
                        y: a.y,
                        left: a.left,
                        top: a.top,
                        right: a.right,
                        bottom: a.bottom,
                        width: a.width,
                        height: a.height,
                        bounds: a,
                        scrollLeft: o.left,
                        scrollTop: o.top,
                        scrollLeftMax: o.leftMax,
                        scrollTopMax: o.topMax,
                        scrollWidth: o.width,
                        scrollHeight: o.height,
                        scroll: o
                    };
                    t.forEach(i, function(t) {
                        if (t in e.result) e.locals[t] = e.result[t];
                        else throw "No such measurement as " + t;
                    });
                    return t.findNext(this, e);
                }
            };
        });
        e.addLeafExpression("closestExpr", function(e, t, r) {
            if (r.matchToken("closest")) {
                if (r.matchToken("parent")) var n = true;
                var i = null;
                if (r.currentToken().type === "ATTRIBUTE_REF") {
                    var a = e.requireElement("attributeRefAccess", r, null);
                    i = "[" + a.attribute.name + "]";
                }
                if (i == null) {
                    var o = e.requireElement("expression", r);
                    if (o.css == null) e.raiseParseError(r, "Expected a CSS expression");
                    else i = o.css;
                }
                if (r.matchToken("to")) var s = e.parseElement("expression", r);
                else var s = e.parseElement("implicitMeTarget", r);
                var u = {
                    type: "closestExpr",
                    parentSearch: n,
                    expr: o,
                    css: i,
                    to: s,
                    args: [
                        s
                    ],
                    op: function(e, r) {
                        if (r == null) return null;
                        else {
                            let e = [];
                            t.implicitLoop(r, function(t) {
                                if (n) e.push(t.parentElement ? t.parentElement.closest(i) : null);
                                else e.push(t.closest(i));
                            });
                            if (t.shouldAutoIterate(r)) return e;
                            else return e[0];
                        }
                    },
                    evaluate: function(e) {
                        return t.unifiedEval(this, e);
                    }
                };
                if (a) {
                    a.root = u;
                    a.args = [
                        u
                    ];
                    return a;
                } else return u;
            }
        });
        e.addCommand("go", function(e, t, r) {
            if (r.matchToken("go")) {
                if (r.matchToken("back")) var n = true;
                else {
                    r.matchToken("to");
                    if (r.matchToken("url")) {
                        var i = e.requireElement("stringLike", r);
                        var a = true;
                        if (r.matchToken("in")) {
                            r.requireToken("new");
                            r.requireToken("window");
                            var o = true;
                        }
                    } else {
                        r.matchToken("the");
                        var s = r.matchAnyToken("top", "middle", "bottom");
                        var u = r.matchAnyToken("left", "center", "right");
                        if (s || u) r.requireToken("of");
                        var i = e.requireElement("unaryExpression", r);
                        var l = r.matchAnyOpToken("+", "-");
                        if (l) {
                            r.pushFollow("px");
                            try {
                                var c = e.requireElement("expression", r);
                            } finally{
                                r.popFollow();
                            }
                        }
                        r.matchToken("px");
                        var f = r.matchAnyToken("smoothly", "instantly");
                        var m = {
                            block: "start",
                            inline: "nearest"
                        };
                        if (s) {
                            if (s.value === "top") m.block = "start";
                            else if (s.value === "bottom") m.block = "end";
                            else if (s.value === "middle") m.block = "center";
                        }
                        if (u) {
                            if (u.value === "left") m.inline = "start";
                            else if (u.value === "center") m.inline = "center";
                            else if (u.value === "right") m.inline = "end";
                        }
                        if (f) {
                            if (f.value === "smoothly") m.behavior = "smooth";
                            else if (f.value === "instantly") m.behavior = "instant";
                        }
                    }
                }
                var p = {
                    target: i,
                    args: [
                        i,
                        c
                    ],
                    op: function(e, r, i) {
                        if (n) window.history.back();
                        else if (a) {
                            if (r) {
                                if (o) window.open(r);
                                else window.location.href = r;
                            }
                        } else t.implicitLoop(r, function(e) {
                            if (e === window) e = document.body;
                            if (l) {
                                let t = e.getBoundingClientRect();
                                let r = document.createElement("div");
                                let n = l.value === "+" ? i : i * -1;
                                let a = m.inline == "start" || m.inline == "end" ? n : 0;
                                let o = m.block == "start" || m.block == "end" ? n : 0;
                                r.style.position = "absolute";
                                r.style.top = t.top + window.scrollY + o + "px";
                                r.style.left = t.left + window.scrollX + a + "px";
                                r.style.height = t.height + "px";
                                r.style.width = t.width + "px";
                                r.style.zIndex = "" + Number.MIN_SAFE_INTEGER;
                                r.style.opacity = "0";
                                document.body.appendChild(r);
                                setTimeout(function() {
                                    document.body.removeChild(r);
                                }, 100);
                                e = r;
                            }
                            e.scrollIntoView(m);
                        });
                        return t.findNext(p, e);
                    }
                };
                return p;
            }
        });
        r.conversions.dynamicResolvers.push(function(t, r) {
            if (!(t === "Values" || t.indexOf("Values:") === 0)) return;
            var n = t.split(":")[1];
            var i = {};
            var a = e.runtime.implicitLoop.bind(e.runtime);
            a(r, function(e) {
                var t = s(e);
                if (t !== undefined) {
                    i[t.name] = t.value;
                    return;
                }
                if (e.querySelectorAll != undefined) {
                    var r = e.querySelectorAll("input,select,textarea");
                    r.forEach(o);
                }
            });
            if (n) {
                if (n === "JSON") return JSON.stringify(i);
                else if (n === "Form") return new URLSearchParams(i).toString();
                else throw "Unknown conversion: " + n;
            } else return i;
            function o(e) {
                var t = s(e);
                if (t == undefined) return;
                if (i[t.name] == undefined) {
                    i[t.name] = t.value;
                    return;
                }
                if (Array.isArray(i[t.name]) && Array.isArray(t.value)) {
                    i[t.name] = [].concat(i[t.name], t.value);
                    return;
                }
            }
            function s(e) {
                try {
                    var t = {
                        name: e.name,
                        value: e.value
                    };
                    if (t.name == undefined || t.value == undefined) return undefined;
                    if (e.type == "radio" && e.checked == false) return undefined;
                    if (e.type == "checkbox") {
                        if (e.checked == false) t.value = undefined;
                        else if (typeof t.value === "string") t.value = [
                            t.value
                        ];
                    }
                    if (e.type == "select-multiple") {
                        var r = e.querySelectorAll("option[selected]");
                        t.value = [];
                        for(var n = 0; n < r.length; n++)t.value.push(r[n].value);
                    }
                    return t;
                } catch (e) {
                    return undefined;
                }
            }
        });
        r.conversions["HTML"] = function(e) {
            var t = function(e) {
                if (e instanceof Array) return e.map(function(e) {
                    return t(e);
                }).join("");
                if (e instanceof HTMLElement) return e.outerHTML;
                if (e instanceof NodeList) {
                    var r = "";
                    for(var n = 0; n < e.length; n++){
                        var i = e[n];
                        if (i instanceof HTMLElement) r += i.outerHTML;
                    }
                    return r;
                }
                if (e.toString) return e.toString();
                return "";
            };
            return t(e);
        };
        r.conversions["Fragment"] = function(t) {
            var r = document.createDocumentFragment();
            e.runtime.implicitLoop(t, function(e) {
                if (e instanceof Node) r.append(e);
                else {
                    var t = document.createElement("template");
                    t.innerHTML = e;
                    r.append(t.content);
                }
            });
            return r;
        };
    }
    const k = new o, x = k.lexer, g = k.parser;
    function b(e, t) {
        return k.evaluate(e, t);
    }
    function w() {
        var t = Array.from(e.document.querySelectorAll("script[type='text/hyperscript'][src]"));
        Promise.all(t.map(function(e) {
            return fetch(e.src).then(function(e) {
                return e.text();
            });
        })).then((e)=>e.forEach((e)=>S(e))).then(()=>n(function() {
                a();
                k.processNode(document.documentElement);
                document.dispatchEvent(new Event("hyperscript:ready"));
                e.document.addEventListener("htmx:load", function(e) {
                    k.processNode(e.detail.elt);
                });
            }));
        function n(e) {
            if (document.readyState !== "loading") setTimeout(e);
            else document.addEventListener("DOMContentLoaded", e);
        }
        function i() {
            var e = document.querySelector('meta[name="htmx-config"]');
            if (e) return v(e.content);
            else return null;
        }
        function a() {
            var e = i();
            if (e) Object.assign(r, e);
        }
    }
    const S = Object.assign(b, {
        config: r,
        use (e) {
            e(S);
        },
        internals: {
            lexer: x,
            parser: g,
            runtime: k,
            Lexer: n,
            Tokens: i,
            Parser: a,
            Runtime: o
        },
        ElementCollection: m,
        addFeature: g.addFeature.bind(g),
        addCommand: g.addCommand.bind(g),
        addLeafExpression: g.addLeafExpression.bind(g),
        addIndirectExpression: g.addIndirectExpression.bind(g),
        evaluate: k.evaluate.bind(k),
        parse: k.parse.bind(k),
        processNode: k.processNode.bind(k),
        version: "0.9.14",
        browserInit: w
    });
    return S;
});


// Initialize hyperscript.
$10c52594aaf0c6b9$exports.browserInit();
// Telegram Web App SDK
const $17a90f9d043afbbd$var$tg = window.Telegram?.WebApp;
if ($17a90f9d043afbbd$var$tg) {
    // Инициализация Telegram Web App
    $17a90f9d043afbbd$var$tg.ready();
    // Применяем тему Telegram
    $17a90f9d043afbbd$var$tg.expand();
    // Устанавливаем цвета из темы Telegram
    if ($17a90f9d043afbbd$var$tg.themeParams) {
        document.documentElement.style.setProperty('--tg-theme-bg-color', $17a90f9d043afbbd$var$tg.themeParams.bg_color || '#ffffff');
        document.documentElement.style.setProperty('--tg-theme-text-color', $17a90f9d043afbbd$var$tg.themeParams.text_color || '#000000');
        document.documentElement.style.setProperty('--tg-theme-hint-color', $17a90f9d043afbbd$var$tg.themeParams.hint_color || '#999999');
        document.documentElement.style.setProperty('--tg-theme-link-color', $17a90f9d043afbbd$var$tg.themeParams.link_color || '#2481cc');
        document.documentElement.style.setProperty('--tg-theme-button-color', $17a90f9d043afbbd$var$tg.themeParams.button_color || '#2481cc');
        document.documentElement.style.setProperty('--tg-theme-button-text-color', $17a90f9d043afbbd$var$tg.themeParams.button_text_color || '#ffffff');
        document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', $17a90f9d043afbbd$var$tg.themeParams.secondary_bg_color || '#f4f4f5');
    }
    // Функция для активации промпта
    window.activatePrompt = function(promptId, deepLink) {
        // Показываем уведомление
        $17a90f9d043afbbd$var$tg.showAlert("\u041F\u0440\u043E\u043C\u043F\u0442 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D! \u041F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0432 \u0431\u043E\u0442 \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.");
        // Отправляем данные боту
        $17a90f9d043afbbd$var$tg.sendData(JSON.stringify({
            action: 'activate_prompt',
            prompt_id: promptId
        }));
    // Опционально: закрываем Web App после активации
    // tg.close()
    };
    // Устанавливаем главную кнопку для страниц промптов
    window.setMainButton = function(text, promptId, deepLink) {
        $17a90f9d043afbbd$var$tg.MainButton.setText(text);
        $17a90f9d043afbbd$var$tg.MainButton.show();
        $17a90f9d043afbbd$var$tg.MainButton.onClick(()=>{
            window.activatePrompt(promptId, deepLink);
        });
    };
    // Скрыть главную кнопку
    window.hideMainButton = function() {
        $17a90f9d043afbbd$var$tg.MainButton.hide();
    };
    console.log('Telegram Web App initialized', $17a90f9d043afbbd$var$tg.initDataUnsafe);
} else console.warn('Telegram Web App SDK not available');

})();
//# sourceMappingURL=scripts.js.map
